import { Alumnos } from "src/app/interface/alumnos";

export const personas: Alumnos[] = [
  { id: "MTk1MTczNQ==", nombre: "JOSEFINA PEREZ CAMACHO", archivo: "JOSEFINA PEREZ CAMACHO _MTk1MTczNQ==.pdf" },
  { id: "MTk2MTc0MQ==", nombre: "JESUS EMMANUUEL CADENA ROMAN", archivo: "JESUS EMMANUUEL CADENA ROMAN_MTk2MTc0MQ==.pdf" },
  { id: "MTk3MTc1Mg==", nombre: "LILIANA GARCIA RAMIRES", archivo: "LILIANA GARCIA RAMIRES _MTk3MTc1Mg==.pdf" },
  { id: "MTk4MTc2NA==", nombre: "OFELIA ALVAREZ LOPEZ", archivo: "OFELIA ALVAREZ LOPEZ _MTk4MTc2NA==.pdf" },
  { id: "MTk5MTc2OA==", nombre: "MANUEL EUGENIO TORRES MENDEZ", archivo: "MANUEL EUGENIO TORRES MENDEZ _MTk5MTc2OA==.pdf" },
  { id: "MjAwMTc3MQ==", nombre: "DANIEL CORONA LOPEZ", archivo: "DANIEL CORONA LOPEZ _MjAwMTc3MQ==.pdf" },
  { id: "MjAxMTc4Mg==", nombre: "CARLOS URIEL HERMEREGILDO ROMERO", archivo: "CARLOS URIEL HERMEREGILDO ROMERO _MjAxMTc4Mg==.pdf" },
  { id: "MjAyMTc4NQ==", nombre: "KARLA MADRIGAL", archivo: "KARLA MADRIGAL _MjAyMTc4NQ==.pdf" },
  { id: "MjAzMTc5Mw==", nombre: "JOEL BARRERA SANDOVAL", archivo: "JOEL BARRERA SANDOVAL _MjAzMTc5Mw==.pdf" },
  { id: "MjA0MTc5OA==", nombre: "INES LAGUNAS RAMIREZ", archivo: "INES LAGUNAS RAMIREZ _MjA0MTc5OA==.pdf" },
  { id: "MjA1MTgwMw==", nombre: "OLIVER AUGUSTO PEREZ MANRERO", archivo: "OLIVER AUGUSTO PEREZ MANRERO_MjA1MTgwMw==.pdf" },
  { id: "MjA2MTgxMg==", nombre: "ÓSCAR ALVARES SOSA", archivo: "ÓSCAR ALVARES SOSA_MjA2MTgxMg==.pdf" },
  { id: "MjA3MTgyNA==", nombre: "MILDRED ADHEREL RAMIREZ ABREO", archivo: "MILDRED ADHEREL RAMIREZ ABREO_MjA3MTgyNA==.pdf" },
  { id: "MjA4MTgzMg==", nombre: "FERNANDO VERGARA RIVERA", archivo: "FERNANDO VERGARA RIVERA _MjA4MTgzMg==.pdf" },
  { id: "MjA5MTgzNg==", nombre: "GUSTAVO RODRIGUEZ MUÑOS", archivo: "GUSTAVO RODRIGUEZ MUÑOS_MjA5MTgzNg==.pdf" },
  { id: "MjEwMTg0Mg==", nombre: "ANA LILIA QUINTANA GONZALEZ", archivo: "ANA LILIA QUINTANA GONZALEZ _MjEwMTg0Mg==.pdf" },
  { id: "MjExMTg1Ng==", nombre: "MARLON ALEXIS PAREDES", archivo: "MARLON ALEXIS PAREDES_MjExMTg1Ng==.pdf" },
  { id: "MjEyMTg2OQ==", nombre: "SILVINO GARCIA LAGOS", archivo: "SILVINO GARCIA LAGOS_MjEyMTg2OQ==.pdf" },
  { id: "MjEzMTg3Mw==", nombre: "STEFANI TOLEN CHAN", archivo: "STEFANI TOLEN CHAN_MjEzMTg3Mw==.pdf" },
  { id: "MjE0MTg4NQ==", nombre: "MARCO ANTONIO LOPEZ ARELLANO", archivo: "MARCO ANTONIO LOPEZ ARELLANO _MjE0MTg4NQ==.pdf" },
  { id: "MjE1MTg5NQ==", nombre: "BRYAN MIGUEL RODRIGUEZ ESQUIVEL", archivo: "BRYAN MIGUEL RODRIGUEZ ESQUIVEL_MjE1MTg5NQ==.pdf" },
  { id: "MjE2MTkwMg==", nombre: "TOMAS MARIN MARTINEZ", archivo: "TOMAS MARIN MARTINEZ_MjE2MTkwMg==.pdf" },
  { id: "MjE4MTkxNQ==", nombre: "BERTHA LILIA ZAMORA VAQUERA", archivo: "BERTHA LILIA ZAMORA VAQUERA_MjE4MTkxNQ==.pdf" },
  { id: "MjE5MTkyMw==", nombre: "MA GRACIELA MARTINEZ HERNANDEZ", archivo: "MA GRACIELA MARTINEZ HERNANDEZ_MjE5MTkyMw==.pdf" },
  { id: "MjIwMTkyNg==", nombre: "LUIS YAIR HERNANDEZ DEL RIO", archivo: "LUIS YAIR HERNANDEZ DEL RIO_MjIwMTkyNg==.pdf" },
  { id: "MjIxMTkzNQ==", nombre: "NORMA LIDIA JUAREZ LOPEZ", archivo: "NORMA LIDIA JUAREZ LOPEZ_MjIxMTkzNQ==.pdf" },
  { id: "MjIyMTk0OA==", nombre: "MIGUEL ANGEL RAMIREZ MARTINEZ", archivo: "MIGUEL ANGEL RAMIREZ MARTINEZ _MjIyMTk0OA==.pdf" },
  { id: "MjIzMTk1Mw==", nombre: "JUAN RUIZ ESPARZA MARTINEZ", archivo: "JUAN RUIZ ESPARZA MARTINEZ _MjIzMTk1Mw==.pdf" },
  { id: "MjI0MTk2Mg==", nombre: "PERLA ANABEL PEREZ RAMIREZ", archivo: "PERLA ANABEL PEREZ RAMIREZ _MjI0MTk2Mg==.pdf" },
  { id: "MjI1MTk2Nw==", nombre: "JOSE ROBERTO SANCHEZ IBARRA", archivo: "JOSE ROBERTO SANCHEZ IBARRA _MjI1MTk2Nw==.pdf" },
  { id: "MjI2MTk3MQ==", nombre: "EMILIANO ROMERO MORALES", archivo: "EMILIANO ROMERO MORALES _MjI2MTk3MQ==.pdf" },
  { id: "MjI3MTk4Ng==", nombre: "EMILIANO MONTIEL LEAL", archivo: "EMILIANO MONTIEL LEAL _MjI3MTk4Ng==.pdf" },
  { id: "MjI4MTk5Mg==", nombre: "OSCIEL DIAZ ORTEGA", archivo: "OSCIEL DIAZ ORTEGA_MjI4MTk5Mg==.pdf" },
  { id: "MjI5MjAwMw==", nombre: "SAUL HERNANDEZ ESTRADA", archivo: "SAUL HERNANDEZ ESTRADA _MjI5MjAwMw==.pdf" },
  { id: "MjMwMjAxMg==", nombre: "EDWIN ORTEGA BASTIDA", archivo: "EDWIN ORTEGA BASTIDA _MjMwMjAxMg==.pdf" },
  { id: "MjMxMjAyNQ==", nombre: "VICTOR MARTINEZ FERREIRA", archivo: "VICTOR MARTINEZ FERREIRA _MjMxMjAyNQ==.pdf" },
  { id: "MjMyMjAzOA==", nombre: "LESLY ABRIL CARRIZALES FRAGOZO", archivo: "LESLY ABRIL CARRIZALES FRAGOZO _MjMyMjAzOA==.pdf" },
  { id: "MjMzMjA0Ng==", nombre: "CEZAR AZAEL ORTIZ QUIROZ", archivo: "CEZAR AZAEL ORTIZ QUIROZ_MjMzMjA0Ng==.pdf" },
  { id: "MjM0MjA1MQ==", nombre: "AKANE KAZUMI RODRIGUEZ VELAZQUEZ", archivo: "AKANE KAZUMI RODRIGUEZ VELAZQUEZ _MjM0MjA1MQ==.pdf" },
  { id: "MjM1MjA1OA==", nombre: "ANA CLAUDIA NAVA IZARRARAS", archivo: "ANA CLAUDIA NAVA IZARRARAS _MjM1MjA1OA==.pdf" },
  { id: "MjM2MjA1OQ==", nombre: "EDGAR ROBERTO MANJARAZ GARCIA", archivo: "EDGAR ROBERTO MANJARAZ GARCIA_MjM2MjA1OQ==.pdf" },
  { id: "MjM3MjA2MQ==", nombre: "CLAUDIA IVONNE VARGAS BUSTOS", archivo: "CLAUDIA IVONNE VARGAS BUSTOS _MjM3MjA2MQ==.pdf" },
  { id: "MjM4MjA3MQ==", nombre: "OSWALDO CHRISTIAN VALENTIN MIJARES", archivo: "OSWALDO CHRISTIAN VALENTIN MIJARES_MjM4MjA3MQ==.pdf" },
  { id: "MjM4MjA3Mw==", nombre: "MA. DDEL CARMEN ALVAREZ BRIONES", archivo: "MA. DDEL CARMEN ALVAREZ BRIONES _MjM4MjA3Mw==.pdf" },
  { id: "MjQwMjA4Ng==", nombre: "AARON IZAN LORA JUAREZ", archivo: "AARON IZAN LORA JUAREZ _MjQwMjA4Ng==.pdf" },
  { id: "MjQxMjA5MQ==", nombre: "ROBERTO CARLOS CORDERO CASTRO", archivo: "ROBERTO CARLOS CORDERO CASTRO_MjQxMjA5MQ==.pdf" },
  { id: "MjQyMjEwMw==", nombre: "EMILIANO AXEL CASTREJON GONZALEZ", archivo: "EMILIANO AXEL CASTREJON GONZALEZ_MjQyMjEwMw==.pdf" },
  { id: "MjQzMjExNw==", nombre: "FRANCISCO CELESTINO HAU MEDINA", archivo: "FRANCISCO CELESTINO HAU MEDINA_MjQzMjExNw==.pdf" },
  { id: "MjQ0MjEyNw==", nombre: "EVELYN MORALES RIVAS", archivo: "EVELYN MORALES RIVAS_MjQ0MjEyNw==.pdf" },
  { id: "MjQ1MjEzNQ==", nombre: "KARINA FLORES FUENTES", archivo: "KARINA FLORES FUENTES_MjQ1MjEzNQ==.pdf" },
  { id: "MjQ2MjE0OA==", nombre: "IVAN PIZZARA ANAYA", archivo: "IVAN PIZZARA ANAYA_MjQ2MjE0OA==.pdf" },
  { id: "MjQ3MjE1OQ==", nombre: "EDGAR GARCIA RODRUGUEZ", archivo: "EDGAR GARCIA RODRUGUEZ_MjQ3MjE1OQ==.pdf" },
  { id: "MjQ4MjE2NQ==", nombre: "URIEL ANTONIO PEREZ BAUTISTA", archivo: "URIEL ANTONIO PEREZ BAUTISTA_MjQ4MjE2NQ==.pdf" },
  { id: "MjQ5MjE3NQ==", nombre: "JUAN FRANCISCO MAERTINEZ MONJARAZ", archivo: "JUAN FRANCISCO MAERTINEZ MONJARAZ_MjQ5MjE3NQ==.pdf" },
  { id: "MjUwMjE4OA==", nombre: "ESTHER NOELANI HERNANDEZ RODARTE", archivo: "ESTHER NOELANI HERNANDEZ RODARTE _MjUwMjE4OA==.pdf" },
  { id: "MjUxMjE5Mg==", nombre: "MIRIAM CORTES ALVAREZ", archivo: "MIRIAM CORTES ALVAREZ_MjUxMjE5Mg==.pdf" },
  { id: "MjUyMjIwOQ==", nombre: "LUIS ANGEL VERDUZCO DONJUAN", archivo: "LUIS ANGEL VERDUZCO DONJUAN_MjUyMjIwOQ==.pdf" },
  { id: "MjUzMjIxNg==", nombre: "BRYAN ALEXIS MARTINEZ ROMERO", archivo: "BRYAN ALEXIS MARTINEZ ROMERO_MjUzMjIxNg==.pdf" },
  { id: "MjU0MjIyOA==", nombre: "JUAN CARLOS GONZALEZ HERNANDEZ", archivo: "JUAN CARLOS GONZALEZ HERNANDEZ_MjU0MjIyOA==.pdf" },
  { id: "MjU1MjIzMQ==", nombre: "BRYAN ARTURO LARA RUIZ", archivo: "BRYAN ARTURO LARA RUIZ_MjU1MjIzMQ==.pdf" },
  { id: "MjU2MjI0Mg==", nombre: "JOSE FERNANDO FERRER MENDEL", archivo: "JOSE FERNANDO FERRER MENDEL_MjU2MjI0Mg==.pdf" },
  { id: "MjU3MjI1OQ==", nombre: "PÉREZ CONTRERAS HANY NAYMA", archivo: "PÉREZ CONTRERAS HANY NAYMA_MjU3MjI1OQ==.pdf" },
  { id: "MjU4MjI2Mg==", nombre: "PÉREZ CONTRERAS JHOANA HARUMI", archivo: "PÉREZ CONTRERAS JHOANA HARUMI_MjU4MjI2Mg==.pdf" },
  { id: "MjU5MjI2Mw==", nombre: "VALENCIA GARCÍA EYDEN ANDRE", archivo: "VALENCIA GARCÍA EYDEN ANDRE_MjU5MjI2Mw==.pdf" },
  { id: "MjYwMjI2Mw==", nombre: "NEGRETE CUPUL MIGUEL ÁNGEL", archivo: "NEGRETE CUPUL MIGUEL ÁNGEL_MjYwMjI2Mw==.pdf" },
  { id: "MjYxMjI3Mw==", nombre: "REYES GARCÍA MERARY JAZMIN", archivo: "REYES GARCÍA MERARY JAZMIN_MjYxMjI3Mw==.pdf" },
  { id: "MjYyMjI4NQ==", nombre: "MAY RAMÍREZ TIDJANA LUCÍA", archivo: "MAY RAMÍREZ TIDJANA LUCÍA_MjYyMjI4NQ==.pdf" },
  { id: "MjYzMjI5Mw==", nombre: "ROBELO CANCHE DANIEL ALBERTO", archivo: "ROBELO CANCHE DANIEL ALBERTO_MjYzMjI5Mw==.pdf" },
  { id: "MjY0MjMwOA==", nombre: "LARA VELASQUEZ FRANCISCO EDUARDO", archivo: "LARA VELASQUEZ FRANCISCO EDUARDO_MjY0MjMwOA==.pdf" },
  { id: "MjY1MjMxOQ==", nombre: "PAREDES LOPEZ MOISES", archivo: "PAREDES LOPEZ MOISES_MjY1MjMxOQ==.pdf" },
  { id: "MjY2MjMyOA==", nombre: "ABRAJAN FARIAS JUAN CARLOS", archivo: "ABRAJAN FARIAS JUAN CARLOS_MjY2MjMyOA==.pdf" },
  { id: "MjY3MjMzOQ==", nombre: "NOVELO LOZADA VÍCTOR MANUEL", archivo: "NOVELO LOZADA VÍCTOR MANUEL_MjY3MjMzOQ==.pdf" },
  { id: "MjY4MjM0MQ==", nombre: "PENAGOS PÉREZ IRVIN ALEXANDER", archivo: "PENAGOS PÉREZ IRVIN ALEXANDER_MjY4MjM0MQ==.pdf" },
  { id: "MjY5MjM0OA==", nombre: "PUERTO NUÑEZ MILDRED EUGENIA", archivo: "PUERTO NUÑEZ MILDRED EUGENIA_MjY5MjM0OA==.pdf" },
  { id: "MjcwMjM1Mg==", nombre: "LUIS ARMANDO DOMINGUEZ", archivo: "LUIS ARMANDO DOMINGUEZ_MjcwMjM1Mg==.pdf" },
  { id: "MjcxMjM2MQ==", nombre: "OSCAR DANIEL DOMINGUEZ", archivo: "OSCAR DANIEL DOMINGUEZ_MjcxMjM2MQ==.pdf" },
  { id: "MjcyMjM2Nw==", nombre: "KIMBERLY ADELEIN GARCIA SANCHEZ", archivo: "KIMBERLY ADELEIN GARCIA SANCHEZ_MjcyMjM2Nw==.pdf" },
  { id: "MjczMjM3MQ==", nombre: "BRENDA FABELA CERDA", archivo: "BRENDA FABELA CERDA_MjczMjM3MQ==.pdf" },
  { id: "Mjc0MjM4Nw==", nombre: "KARLA LIZBETH VIDAÑA ROMERO", archivo: "KARLA LIZBETH VIDAÑA ROMERO_Mjc0MjM4Nw==.pdf" },
  { id: "Mjc1MjM5MQ==", nombre: "NICOLAS PROA ALCANTARA", archivo: "NICOLAS PROA ALCANTARA_Mjc1MjM5MQ==.pdf" },
  { id: "Mjc2MjQwMw==", nombre: "EMILIANO ESCAMILLA MONTES DE OCA", archivo: "EMILIANO ESCAMILLA MONTES DE OCA_Mjc2MjQwMw==.pdf" },
  { id: "Mjc4MjQxMg==", nombre: "ANGEL JAEL GALVAN LOEZA", archivo: "ANGEL JAEL GALVAN LOEZA_Mjc4MjQxMg==.pdf" },
  { id: "Mjc5MjQyOA==", nombre: "EMILIANO GARCÍA CAUDILLO", archivo: "EMILIANO GARCÍA CAUDILLO _Mjc5MjQyOA==.pdf" },
  { id: "MjgwMjQzMQ==", nombre: "MONSERRATH GARCIA SÁNCHEZ", archivo: "MONSERRATH GARCIA SÁNCHEZ _MjgwMjQzMQ==.pdf" },
  { id: "MjgxMjQ0Nw==", nombre: "JOHANSSEN ELOY GONZÁLEZ SALUB", archivo: "JOHANSSEN ELOY GONZÁLEZ SALUB_MjgxMjQ0Nw==.pdf" },
  { id: "MjgyMjQ1OQ==", nombre: "ELVI ANGELICA AZUETA LÓPEZ", archivo: "ELVI ANGELICA AZUETA LÓPEZ _MjgyMjQ1OQ==.pdf" },
  { id: "MjgzMjQ2Mg==", nombre: "NORMA GEORGINA AZUETA LÓPEZ", archivo: "NORMA GEORGINA AZUETA LÓPEZ_MjgzMjQ2Mg==.pdf" },
  { id: "Mjg0MjQ3OQ==", nombre: "MARICELA CHÁVEZ RODRÍGUEZ", archivo: "MARICELA CHÁVEZ RODRÍGUEZ_Mjg0MjQ3OQ==.pdf" },
  { id: "Mjg1MjQ4Mg==", nombre: "MARGARITA OVANDO ALVAREZ", archivo: "MARGARITA OVANDO ALVAREZ_Mjg1MjQ4Mg==.pdf" },
  { id: "Mjg2MjQ5Mw==", nombre: "MILDRE MICHEL ABREGO URREA", archivo: "MILDRE MICHEL ABREGO URREA_Mjg2MjQ5Mw==.pdf" },
  { id: "Mjg3MjUwOQ==", nombre: "YULI JOKONDA ESCOBAR MATOS", archivo: "YULI JOKONDA ESCOBAR MATOS_Mjg3MjUwOQ==.pdf" },
  { id: "Mjg4MjUxNw==", nombre: "SHIRLEY SARAI NOVELO QUIÑONES", archivo: "SHIRLEY SARAI NOVELO QUIÑONES _Mjg4MjUxNw==.pdf" },
  { id: "Mjg5MjUyOA==", nombre: "RAYMUNDO PECH PECH", archivo: "RAYMUNDO PECH PECH_Mjg5MjUyOA==.pdf" },
  { id: "MjkwMjUzNw==", nombre: "MARÍA FERNANDA LÓPEZ HURTADO", archivo: "MARÍA FERNANDA LÓPEZ HURTADO _MjkwMjUzNw==.pdf" },
  { id: "MjkxMjU0OA==", nombre: "NOEMÍ RODRÍGUEZ BERUME", archivo: "NOEMÍ RODRÍGUEZ BERUME_MjkxMjU0OA==.pdf" },
  { id: "MjkyMjU1OA==", nombre: "FATIMA CARMEN DEL ROSARIO GONZÁLEZ URISTA", archivo: "FATIMA CARMEN DEL ROSARIO GONZÁLEZ URISTA _MjkyMjU1OA==.pdf" },
  { id: "MjkzMjU2Nw==", nombre: "JOSÉ LUIS ZAMORA ALVARADO", archivo: "JOSÉ LUIS ZAMORA ALVARADO_MjkzMjU2Nw==.pdf" },
  { id: "Mjk0MjU2NA==", nombre: "IRVING YAEL ÁLVAREZ HERNÁNDEZ", archivo: "IRVING YAEL ÁLVAREZ HERNÁNDEZ _Mjk0MjU2NA==.pdf" },
  { id: "Mjk1MjU3OA==", nombre: "ANA LAURA ENGUILO SHINGU", archivo: "ANA LAURA ENGUILO SHINGU _Mjk1MjU3OA==.pdf" },
  { id: "Mjk3MjU4NA==", nombre: "JOSÉ ELISEO ESTRELLA HOIL", archivo: "JOSÉ ELISEO ESTRELLA HOIL_Mjk3MjU4NA==.pdf" },
  { id: "Mjk4MjU5Mg==", nombre: "CLARITA ESMERALDA LIANEZ YAM", archivo: "CLARITA ESMERALDA LIANEZ YAM_Mjk4MjU5Mg==.pdf" },
  { id: "Mjk5MjU5Nw==", nombre: "Francisco Javier Tapia Carrillo", archivo: "Francisco Javier Tapia Carrillo_Mjk5MjU5Nw==.pdf" },
  { id: "MzAwMjYwNg==", nombre: "ESPIRIDION EDUARDO ANTONIO TAPIA HERNADEZ", archivo: "ESPIRIDION EDUARDO ANTONIO TAPIA HERNADEZ _MzAwMjYwNg==.pdf" },
  { id: "MzAxMjYxMw==", nombre: "IGNACIO IARLEY CARMONA PALACIOS", archivo: "IGNACIO IARLEY CARMONA PALACIOS_MzAxMjYxMw==.pdf" },
  // Tercer Lote

  {
    id: "MzA3LjAyNzE4LjA=",
    nombre: "DANIEL PAEZ FLORES",
    archivo: "DANIEL PAEZ FLORES_MzA3LjAyNzE4LjA="
  },
  {
    id: "MzExLjAyNzIwLjA=",
    nombre: "ITZIA NAOMI CRUZ FRAUSTO",
    archivo: "ITZIA NAOMI CRUZ FRAUSTO_MzExLjAyNzIwLjA="
  },
  {
    id: "MzI3LjAyNzI3LjA=",
    nombre: "VICTOR MAY MAY",
    archivo: "VICTOR MAY MAY_MzI3LjAyNzI3LjA="
  },
  {
    id: "MzA0LjAyNzM0LjA=",
    nombre: "ALDO FRANCISCO LOPEZ HERNANDEZ",
    archivo: "ALDO FRANCISCO LOPEZ HERNANDEZ_MzA0LjAyNzM0LjA="
  },
  {
    id: "MzMxLjAyNzQwLjA=",
    nombre: "ANDREA ELISEA SERVIN ALPIZAR",
    archivo: "ANDREA ELISEA SERVIN ALPIZAR_MzMxLjAyNzQwLjA="
  },
  {
    id: "MzM3LjAyNzQ3LjA=",
    nombre: "AXEL DIDIER ACOSTA EMILIANO",
    archivo: "AXEL DIDIER ACOSTA EMILIANO_MzM3LjAyNzQ3LjA="
  },
  {
    id: "MzAzLjAyNzU0LjA=",
    nombre: "BETSAIDA MONSERRATH CAVAZOS PEREZ",
    archivo: "BETSAIDA MONSERRATH CAVAZOS PEREZ_MzAzLjAyNzU0LjA="
  },
  {
    id: "MzA1LjAyNzYxLjA=",
    nombre: "BETSY MARCELA MARIN SANCHEZ",
    archivo: "BETSY MARCELA MARIN SANCHEZ_MzA1LjAyNzYxLjA="
  },
  {
    id: "MzAyLjAyNzY4LjA=",
    nombre: "BRENDA MARTINEZ BAÑOS",
    archivo: "BRENDA MARTINEZ BAÑOS_MzAyLjAyNzY4LjA="
  },
  {
    id: "MzMzLjAyNzc0LjA=",
    nombre: "CRISTOFER MIGUEL VAZQUEZ CHAVEZ",
    archivo: "CRISTOFER MIGUEL VAZQUEZ CHAVEZ_MzMzLjAyNzc0LjA="
  },
  {
    id: "MzMwLjAyNzg1LjA=",
    nombre: "DAVID MUÑOZ HERNANDEZ",
    archivo: "DAVID MUÑOZ HERNANDEZ_MzMwLjAyNzg1LjA="
  },
  {
    id: "MzA2LjAyNzkyLjA=",
    nombre: "GAMALIEL EMIR MARTINEZ ESPINOZA",
    archivo: "GAMALIEL EMIR MARTINEZ ESPINOZA_MzA2LjAyNzkyLjA="
  },
  {
    id: "MzA5LjAyNzEwLjA=",
    nombre: "GRACIELA DOMINGUEZ MORALEZ",
    archivo: "GRACIELA DOMINGUEZ MORALEZ_MzA5LjAyNzEwLjA="
  },
  {
    id: "MzEwLjAyNzAyLjA=",
    nombre: "GUADALUPE ANAYA BALBUENA",
    archivo: "GUADALUPE ANAYA BALBUENA_MzEwLjAyNzAyLjA="
  },
  {
    id: "MzA4LjAyODEzLjA=",
    nombre: "GUSTAVO HERNANDEZ FONT",
    archivo: "GUSTAVO HERNANDEZ FONT_MzA4LjAyODEzLjA="
  },
  {
    id: "MzEzLjAyODEwLjA=",
    nombre: "JAIRO ISAI LARA VALENZUELA",
    archivo: "JAIRO ISAI LARA VALENZUELA_MzEzLjAyODEwLjA="
  },
  {
    id: "MzQxLjAyODE3LjA=",
    nombre: "JENY GUADALUPE GONZALEZ ROMERO",
    archivo: "JENY GUADALUPE GONZALEZ ROMERO_MzQxLjAyODE3LjA="
  },
  {
    id: "MzEyLjAyODI1LjA=",
    nombre: "JESUS DANIEL DIAZ MARMOLEJO",
    archivo: "JESUS DANIEL DIAZ MARMOLEJO_MzEyLjAyODI1LjA="
  },
  {
    id: "MzE0LjAyODMwLjA=",
    nombre: "JOSE ALBERTO GARCIA CHAVEZ",
    archivo: "JOSE ALBERTO GARCIA CHAVEZ_MzE0LjAyODMwLjA="
  },
  {
    id: "MzM0LjAyODM2LjA=",
    nombre: "JOSE MAURICIO GONZALEZ RIVERA",
    archivo: "JOSE MAURICIO GONZALEZ RIVERA_MzM0LjAyODM2LjA="
  },
  {
    id: "MzM4LjAyODQyLjA=",
    nombre: "JUAN NICOLAS HERNANDEZ FLORES",
    archivo: "JUAN NICOLAS HERNANDEZ FLORES_MzM4LjAyODQyLjA="
  },
  {
    id: "MzE1LjAyODQ4LjA=",
    nombre: "KARLA SHIRLEY GARCIA RODRIGUEZ",
    archivo: "KARLA SHIRLEY GARCIA RODRIGUEZ_MzE1LjAyODQ4LjA="
  },
  {
    id: "MzQwLjAyODUwLjA=",
    nombre: "LAURENTINO VELAZQUEZ GONZALEZ",
    archivo: "LAURENTINO VELAZQUEZ GONZALEZ_MzQwLjAyODUwLjA="
  },
  {
    id: "MzIwLjAyODU1LjA=",
    nombre: "LEONARDO VILCHIS GARFIAS",
    archivo: "LEONARDO VILCHIS GARFIAS_MzIwLjAyODU1LjA="
  },
  {
    id: "MzM2LjAyODYwLjA=",
    nombre: "LILIANA PATRICIA BECERRA VILLA",
    archivo: "LILIANA PATRICIA BECERRA VILLA_MzM2LjAyODYwLjA="
  },
  {
    id: "MzE5LjAyODY4LjA=",
    nombre: "LUIS MIGUEL ROMAN LOPEZ",
    archivo: "LUIS MIGUEL ROMAN LOPEZ_MzE5LjAyODY4LjA="
  },
  {
    id: "MzE3LjAyODc0LjA=",
    nombre: "MAHETSI FERNANDA CARIAGA",
    archivo: "MAHETSI FERNANDA CARIAGA_MzE3LjAyODc0LjA="
  },
  {
    id: "MzM1LjAyODc4LjA=",
    nombre: "MARCO ANTONIO GARCIA SUAREZ",
    archivo: "MARCO ANTONIO GARCIA SUAREZ_MzM1LjAyODc4LjA="
  },
  {
    id: "MzQzLjAyODgxLjA=",
    nombre: "MARIA DEL ROSARIO GUZMAN HERRADA",
    archivo: "MARIA DEL ROSARIO GUZMAN HERRADA_MzQzLjAyODgxLjA="
  },
  {
    id: "MzE4LjAyODg5LjA=",
    nombre: "MARIA JOSE GALLEGOS DELGADO",
    archivo: "MARIA JOSE GALLEGOS DELGADO_MzE4LjAyODg5LjA="
  },
  {
    id: "MzMyLjAyODkxLjA=",
    nombre: "MARIO OSWALDO GUERRERO CRUZ",
    archivo: "MARIO OSWALDO GUERRERO CRUZ_MzMyLjAyODkxLjA="
  },
  {
    id: "MzE2LjAyODk5LjA=",
    nombre: "MARISOL ESCALONA RODRIGUEZ",
    archivo: "MARISOL ESCALONA RODRIGUEZ_MzE2LjAyODk5LjA="
  },
  {
    id: "MzI0LjAyOTEwLjA=",
    nombre: "MATEO ARRIAGA FLORES",
    archivo: "MATEO ARRIAGA FLORES_MzI0LjAyOTEwLjA="
  },
  {
    id: "MzIxLjAyOTE1LjA=",
    nombre: "MAURICIO ROSALES SANCHEZ",
    archivo: "MAURICIO ROSALES SANCHEZ_MzIxLjAyOTE1LjA="
  },
  {
    id: "MzIzLjAyOTIwLjA=",
    nombre: "MAYELA LOPEZ HERNANDEZ",
    archivo: "MAYELA LOPEZ HERNANDEZ_MzIzLjAyOTIwLjA="
  },
  {
    id: "MzI1LjAyOTI2LjA=",
    nombre: "MAYRA PATRICIA RODRIGUEZ LOPEZ",
    archivo: "MAYRA PATRICIA RODRIGUEZ LOPEZ_MzI1LjAyOTI2LjA="
  },
  {
    id: "MzQyLjAyOTMyLjA=",
    nombre: "MIRIAM MARTINEZ MENDOZA",
    archivo: "MIRIAM MARTINEZ MENDOZA_MzQyLjAyOTMyLjA="
  },
  {
    id: "MzM5LjAyOTM4LjA=",
    nombre: "RAMIRO MAYA GOMEZ",
    archivo: "RAMIRO MAYA GOMEZ_MzM5LjAyOTM4LjA="
  },
  {
    id: "MzIyLjAyOTQ1LjA=",
    nombre: "SAYURI KRYTZEL CARRIZALES FRAGOSO",
    archivo: "SAYURI KRYTZEL CARRIZALES FRAGOSO_MzIyLjAyOTQ1LjA="
  },
  {
    id: "MzI5LjAyOTUxLjA=",
    nombre: "SEBASTIAN NICOLAS CHAVERRI SANCHEZ",
    archivo: "SEBASTIAN NICOLAS CHAVERRI SANCHEZ_MzI5LjAyOTUxLjA="
  },
  {
    id: "MzI4LjAyOTU3LjA=",
    nombre: "SERGIO MEDINA DE LA PEÑA",
    archivo: "SERGIO MEDINA DE LA PEÑA_MzI4LjAyOTU3LjA="
  },
  {
    id: "MzI2LjAyOTY0LjA=",
    nombre: "XIMENA ABIGAIL ROMERO TRISTAN",
    archivo: "XIMENA ABIGAIL ROMERO TRISTAN_MzI2LjAyOTY0LjA="
  },
  // Nuevo lote de 20
  {
    id: "MzQ0Mjk3MA==",
    nombre: "EMILIO ALEJANDRO RODRIGUEZ RETANO",
    archivo: "EMILIO ALEJANDRO RODRIGUEZ RETANO_MzQ0Mjk3MA=="
  },
  {
    id: "MzQ1Mjk3NQ==",
    nombre: "LUCERO GUADALUPE PILLADO LOPEZ",
    archivo: "LUCERO GUADALUPE PILLADO LOPEZ_MzQ1Mjk3NQ=="
  },
  {
    id: "MzQ2Mjk4MA==",
    nombre: "SOFIA GISSEL MENDEZ VIDAL",
    archivo: "SOFIA GISSEL MENDEZ VIDAL_MzQ2Mjk4MA=="
  },
  {
    id: "MzQ3Mjk4NQ==",
    nombre: "ALVARO ALEJANDRO OBREGON GASTELUM",
    archivo: "ALVARO ALEJANDRO OBREGON GASTELUM_MzQ3Mjk4NQ=="
  },
  {
    id: "MzQ4Mjk5MA==",
    nombre: "GUILLERMO MARTINEZ MARISCAL",
    archivo: "GUILLERMO MARTINEZ MARISCAL_MzQ4Mjk5MA=="
  },
  {
    id: "MzQ5Mjk5NQ==",
    nombre: "MARIO HERNANDEZ MOJICA",
    archivo: "MARIO HERNANDEZ MOJICA_MzQ5Mjk5NQ=="
  },
  {
    id: "MzUwMzAwNQ==",
    nombre: "DIANA BELIA ANDRADE PIÑA",
    archivo: "DIANA BELIA ANDRADE PIÑA_MzUwMzAwNQ=="
  },
  {
    id: "MzUxMzAxMA==",
    nombre: "ALAN OMAR CANTO DOMINGUEZ",
    archivo: "ALAN OMAR CANTO DOMINGUEZ_MzUxMzAxMA=="
  },
  {
    id: "MzUyMzAxNQ==",
    nombre: "DAVID GENARO SUAREZ MENDOZA",
    archivo: "DAVID GENARO SUAREZ MENDOZA_MzUyMzAxNQ=="
  },
  {
    id: "MzUzMzAyMA==",
    nombre: "JUAN ALBERTO MONGE SALAZAR",
    archivo: "JUAN ALBERTO MONGE SALAZAR_MzUzMzAyMA=="
  },
  {
    id: "MzU0MzAyNQ==",
    nombre: "EDGAR JAZIEL ROBLES GARCIA",
    archivo: "EDGAR JAZIEL ROBLES GARCIA_MzU0MzAyNQ=="
  },
  {
    id: "MzU1MzAzMA==",
    nombre: "GEORGINA CARRILLO CLETO",
    archivo: "GEORGINA CARRILLO CLETO_MzU1MzAzMA=="
  },
  {
    id: "MzU2MzAzNQ==",
    nombre: "CRUZ ZOBEYDA ATONDO GARCIA",
    archivo: "CRUZ ZOBEYDA ATONDO GARCIA_MzU2MzAzNQ=="
  },
  {
    id: "MzU3MzA0MA==",
    nombre: "VICTOR ALONSO SAENZ SOLIS",
    archivo: "VICTOR ALONSO SAENZ SOLIS_MzU3MzA0MA=="
  },
  {
    id: "MzU4MzA0NQ==",
    nombre: "CAMILLE CITLALY DE LOS SANTOS GALAVIZ",
    archivo: "CAMILLE CITLALY DE LOS SANTOS GALAVIZ_MzU4MzA0NQ=="
  },
  {
    id: "MzU5MzA1MA==",
    nombre: "RAFAEL MORALES MENDOZA",
    archivo: "RAFAEL MORALES MENDOZA_MzU5MzA1MA=="
  },
  {
    id: "MzYwMzA1Ng==",
    nombre: "FRANCISCO DANIEL RUVALCABA ALCALA",
    archivo: "FRANCISCO DANIEL RUVALCABA ALCALA_MzYwMzA1Ng=="
  },
  {
    id: "MzYxMzA2Mg==",
    nombre: "JAVIER MICHEL ARVIZU RUIZ",
    archivo: "JAVIER MICHEL ARVIZU RUIZ_MzYxMzA2Mg=="
  },
  {
    id: "MzYyMzA2OQ==",
    nombre: "GENESIS MICHELLE RANGEL ZARAGOZA",
    archivo: "GENESIS MICHELLE RANGEL ZARAGOZA_MzYyMzA2OQ=="
  },
  {
    id: "MzYzMzA3Ng==",
    nombre: "YESENIA GUZMAN NOLASCO",
    archivo: "YESENIA GUZMAN NOLASCO_MzYzMzA3Ng=="
  },
  //store5
  {
    "id": "MzY0LjAzODAuMA==",
    "nombre": "Silvia Callejas González",
    "archivo": "Silvia Callejas González _MzY0LjAzODAuMA=="
  },
  {
    "id": "MzY1LjAzODUuMA==",
    "nombre": "Gabriela Reyes San Juan",
    "archivo": "Gabriela Reyes San Juan _MzY1LjAzODUuMA=="
  },
  {
    "id": "MzY2LjAzOTAuMA==",
    "nombre": "Paulina Yulitza Martínez López",
    "archivo": "Paulina Yulitza Martínez López _MzY2LjAzOTAuMA=="
  },
  {
    "id": "MzY3LjAzOTMuMA==",
    "nombre": "Fernanda Paulina Contreras Ramírez",
    "archivo": "Fernanda Paulina Contreras Ramírez _MzY3LjAzOTMuMA=="
  },
  {
    "id": "MzY4LjAzOTYuMA==",
    "nombre": "Yeni Gabriela Terán Romero",
    "archivo": "Yeni Gabriela Terán Romero _MzY4LjAzOTYuMA=="
  },
  {
    "id": "MzY5LjAzOTkuMA==",
    "nombre": "Ivanna Alin González Jiménez",
    "archivo": "Ivanna Alin González Jiménez _MzY5LjAzOTkuMA=="
  },
  {
    "id": "MzcwLjA0MDUuMA==",
    "nombre": "Mayrin Adriana Orozco Gutiérrez",
    "archivo": "Mayrin Adriana Orozco Gutiérrez _MzcwLjA0MDUuMA=="
  },
  {
    "id": "MzcxLjA0MTAuMA==",
    "nombre": "Ángel Thonatiu Ramos Lugo",
    "archivo": "Ángel Thonatiu Ramos Lugo _MzcxLjA0MTAuMA=="
  },
  {
    "id": "MzcyLjA0MTUuMA==",
    "nombre": "Luis Ángel Felipe Rojas",
    "archivo": "Luis Ángel Felipe Rojas _MzcyLjA0MTUuMA=="
  },
  {
    "id": "MzczLjA0MjAuMA==",
    "nombre": "Dariel Moisés Lugo Bazán",
    "archivo": "Dariel Moisés Lugo Bazán _MzczLjA0MjAuMA=="
  },
  {
    "id": "Mzc0LjA0MjMuMA==",
    "nombre": "Estrella Jazmin Hernández Ruiz",
    "archivo": "Estrella Jazmin Hernández Ruiz _Mzc0LjA0MjMuMA=="
  },
  {
    "id": "Mzc1LjA0MjYuMA==",
    "nombre": "María Del Pilar Yazmín Ibáñez Camacho",
    "archivo": "María Del Pilar Yazmín Ibáñez Camacho _Mzc1LjA0MjYuMA=="
  },
  {
    "id": "Mzc2LjA0MjkuMA==",
    "nombre": "Edgar Alejandro Berrelleza Guerrero",
    "archivo": "Edgar Alejandro Berrelleza Guerrero _Mzc2LjA0MjkuMA=="
  },
  {
    "id": "Mzc3LjA0MzUuMA==",
    "nombre": "Francisco Manuel Egurrola Ortiz",
    "archivo": "Francisco Manuel Egurrola Ortiz _Mzc3LjA0MzUuMA=="
  },
  {
    "id": "Mzc4LjA0NDAuMA==",
    "nombre": "Alicia Esther Serrano García",
    "archivo": "Alicia Esther Serrano García _Mzc4LjA0NDAuMA=="
  },
  {
    "id": "Mzc5LjA0NDUuMA==",
    "nombre": "Camila González Herrera",
    "archivo": "Camila González Herrera _Mzc5LjA0NDUuMA=="
  },
  {
    "id": "MzgwLjA0NTAuMA==",
    "nombre": "Brenda Araceli Pacheco González",
    "archivo": "Brenda Araceli Pacheco González _MzgwLjA0NTAuMA=="
  },
  {
    "id": "MzgxLjA0NTUuMA==",
    "nombre": "Jesús David Quintero Bustillos",
    "archivo": "Jesús David Quintero Bustillos _MzgxLjA0NTUuMA=="
  },
  {
    "id": "MzgyLjA0NjAuMA==",
    "nombre": "Diego Marcelo Alvear Carreón",
    "archivo": "Diego Marcelo Alvear Carreón _MzgyLjA0NjAuMA=="
  },
  {
    "id": "MzgzLjA0NjMuMA==",
    "nombre": "Ángel Gabriel Valenzuela Tena",
    "archivo": "Ángel Gabriel Valenzuela Tena _MzgzLjA0NjMuMA=="
  },
  {
    "id": "Mzg0LjA0NjYuMA==",
    "nombre": "Marcela Carpio Orozco",
    "archivo": "Marcela Carpio Orozco _Mzg0LjA0NjYuMA=="
  },
  {
    "id": "Mzg1LjA0NjkuMA==",
    "nombre": "Ulises Leonardo Pantoja Flores",
    "archivo": "Ulises Leonardo Pantoja Flores _Mzg1LjA0NjkuMA=="
  },
  {
    "id": "Mzg2LjA0NzIuMA==",
    "nombre": "Luisa Marily Pano",
    "archivo": "Luisa Marily Pano _Mzg2LjA0NzIuMA=="
  },
  {
    "id": "Mzg3LjA0NzUuMA==",
    "nombre": "María Eugenia Bautista",
    "archivo": "María Eugenia Bautista _Mzg3LjA0NzUuMA=="
  },
  {
    "id": "Mzg4LjA0ODAuMA==",
    "nombre": "María Ángela Zúñiga Pineda",
    "archivo": "María Ángela Zúñiga Pineda _Mzg4LjA0ODAuMA=="
  },
  {
    "id": "Mzg5LjA0ODUuMA==",
    "nombre": "Marcelo Daniel Ramos Capetillo",
    "archivo": "Marcelo Daniel Ramos Capetillo _Mzg5LjA0ODUuMA=="
  },
  {
    "id": "MzkwLjA0OTAuMA==",
    "nombre": "Aurora Regina Micalco López Monsiváis",
    "archivo": "Aurora Regina Micalco López Monsiváis _MzkwLjA0OTAuMA=="
  },
  {
    "id": "MzkxLjA0OTMuMA==",
    "nombre": "Karen Cristina Guadarrama Salazar",
    "archivo": "Karen Cristina Guadarrama Salazar _MzkxLjA0OTMuMA=="
  },
  {
    "id": "MzkyLjA0OTYuMA==",
    "nombre": "Víctor Bernal González",
    "archivo": "Víctor Bernal González _MzkyLjA0OTYuMA=="
  },
  {
    "id": "MzkzLjA0OTkuMA==",
    "nombre": "Yoselin Alva Miranda",
    "archivo": "Yoselin Alva Miranda _MzkzLjA0OTkuMA=="
  },
  {
    "id": "Mzk0LjA1MDUuMA==",
    "nombre": "María Fernanda Luna Hernández",
    "archivo": "María Fernanda Luna Hernández _Mzk0LjA1MDUuMA=="
  },
  {
    "id": "Mzk1LjA1MTAuMA==",
    "nombre": "Luz Viviana López Martínez",
    "archivo": "Luz Viviana López Martínez _Mzk1LjA1MTAuMA=="
  },
  {
    "id": "Mzk2LjA1MTUuMA==",
    "nombre": "Yataniel Martínez Sánchez",
    "archivo": "Yataniel Martínez Sánchez _Mzk2LjA1MTUuMA=="
  },
  {
    "id": "Mzk3LjA1MjAuMA==",
    "nombre": "José Manuel Sánchez Díaz",
    "archivo": "José Manuel Sánchez Díaz _Mzk3LjA1MjAuMA=="
  },
  {
    "id": "Mzk4LjA1MjUuMA==",
    "nombre": "Rodrigo Galván Madrigal",
    "archivo": "Rodrigo Galván Madrigal _Mzk4LjA1MjUuMA=="
  },
  {
    "id": "Mzk5LjA1MzAuMA==",
    "nombre": "Mariel Jarvio Mondragón",
    "archivo": "Mariel Jarvio Mondragón _Mzk5LjA1MzAuMA=="
  },
  {
    "id": "NDAwLjA1MzMuMA==",
    "nombre": "Vadhir Alexander Vargas Flores",
    "archivo": "Vadhir Alexander Vargas Flores _NDAwLjA1MzMuMA=="
  },
  {
    "id": "NDAxLjA1MzYuMA==",
    "nombre": "Lee-Ann Romina Escutia Zúñiga",
    "archivo": "Lee-Ann Romina Escutia Zúñiga _NDAxLjA1MzYuMA=="
  },
  {
    "id": "NDAyLjA1MzkuMA==",
    "nombre": "Miriam Beatriz Méndez Mateos",
    "archivo": "Miriam Beatriz Méndez Mateos _NDAyLjA1MzkuMA=="
  },
  {
    "id": "NDAzLjA1NDIuMA==",
    "nombre": "Rocio Virginia Bobadilla Chicho",
    "archivo": "Rocio Virginia Bobadilla Chicho _NDAzLjA1NDIuMA=="
  },
  {
    "id": "NDA0LjA1NDUuMA==",
    "nombre": "Antonio Olán Romero",
    "archivo": "Antonio Olán Romero _NDA0LjA1NDUuMA=="
  },
  {
    "id": "NDA1LjA1NTAuMA==",
    "nombre": "Diego Emiliano Solís Vázquez",
    "archivo": "Diego Emiliano Solís Vázquez _NDA1LjA1NTAuMA=="
  },
  {
    "id": "NDA2LjA1NTUuMA==",
    "nombre": "Sandra Romero De Luna",
    "archivo": "Sandra Romero De Luna _NDA2LjA1NTUuMA=="
  },
  {
    "id": "NDA3LjA1NjAuMA==",
    "nombre": "Javier Mendoza Martínez",
    "archivo": "Javier Mendoza Martínez _NDA3LjA1NjAuMA=="
  },
  {
    "id": "NDA4LjA1NjUuMA==",
    "nombre": "Kristtel Guadalupe Ramos Hernández",
    "archivo": "Kristtel Guadalupe Ramos Hernández _NDA4LjA1NjUuMA=="
  },
  {
    "id": "NDA5LjA1NzAuMA==",
    "nombre": "Andrés Roa Espinal",
    "archivo": "Andrés Roa Espinal _NDA5LjA1NzAuMA=="
  },
  {
    "id": "NDEwLjA1NzUuMA==",
    "nombre": "Sebastián Alejandro Esquivel Victorio",
    "archivo": "Sebastián Alejandro Esquivel Victorio _NDEwLjA1NzUuMA=="
  },
  {
    "id": "NDExLjA1ODAuMA==",
    "nombre": "Ramón Martínez Martínez",
    "archivo": "Ramón Martínez Martínez _NDExLjA1ODAuMA=="
  },
  {
    "id": "NDEyLjA1ODMuMA==",
    "nombre": "Mauricio Daniel Sánchez Juárez",
    "archivo": "Mauricio Daniel Sánchez Juárez _NDEyLjA1ODMuMA=="
  },
  {
    "id": "NDEzLjA1ODYuMA==",
    "nombre": "Kenia Guadalupe Carrillo Sánchez",
    "archivo": "Kenia Guadalupe Carrillo Sánchez _NDEzLjA1ODYuMA=="
  },
  {
    "id": "NDE0LjA1ODkuMA==",
    "nombre": "Genny Vanessa Rosas Muciño",
    "archivo": "Genny Vanessa Rosas Muciño _NDE0LjA1ODkuMA=="
  },
  {
    "id": "NDE1LjA1OTIuMA==",
    "nombre": "Benjamín Rodríguez Miranda",
    "archivo": "Benjamín Rodríguez Miranda _NDE1LjA1OTIuMA=="
  },
  {
    "id": "NDE2LjA1OTUuMA==",
    "nombre": "Camila Aguilar Fajardo",
    "archivo": "Camila Aguilar Fajardo _NDE2LjA1OTUuMA=="
  },
  {
    "id": "NDE3LjA2MDAuMA==",
    "nombre": "Ignacio Miranda Sánchez",
    "archivo": "Ignacio Miranda Sánchez _NDE3LjA2MDAuMA=="
  },
  {
    "id": "NDE4LjA2MDUuMA==",
    "nombre": "Denilzon Eliuh Balderas Cocom",
    "archivo": "Denilzon Eliuh Balderas Cocom _NDE4LjA2MDUuMA=="
  },
  {
    "id": "NDE5LjA2MTAuMA==",
    "nombre": "Romelia Medina Cázares",
    "archivo": "Romelia Medina Cázares _NDE5LjA2MTAuMA=="
  },
  {
    "id": "NDIwLjA2MTUuMA==",
    "nombre": "Ricardo Alcántara Pérez",
    "archivo": "Ricardo Alcántara Pérez _NDIwLjA2MTUuMA=="
  },
  {
    "id": "NDIxLjA2MjAuMA==",
    "nombre": "Diana Guzmán Martínez",
    "archivo": "Diana Guzmán Martínez _NDIxLjA2MjAuMA=="
  },
  {
    "id": "NDIyLjA2MjMuMA==",
    "nombre": "Carlos Alberto Delgado Correa",
    "archivo": "Carlos Alberto Delgado Correa _NDIyLjA2MjMuMA=="
  },
  {
    "id": "NDIzLjA2MjYuMA==",
    "nombre": "Estefani Jimena Rosas Nieves",
    "archivo": "Estefani Jimena Rosas Nieves _NDIzLjA2MjYuMA=="
  },
  {
    "id": "NDI0LjA2MjkuMA==",
    "nombre": "Renata Moreno Palomares",
    "archivo": "Renata Moreno Palomares _NDI0LjA2MjkuMA=="
  },
  {
    "id": "NDI1LjA2MzIuMA==",
    "nombre": "Juan Carlos Guevara Carranza",
    "archivo": "Juan Carlos Guevara Carranza _NDI1LjA2MzIuMA=="
  },
  {
    "id": "NDI2LjA2MzUuMA==",
    "nombre": "Sofía Valentina Martínez Teyssier Villanueva",
    "archivo": "Sofía Valentina Martínez Teyssier Villanueva _NDI2LjA2MzUuMA=="
  },
  {
    "id": "NDI3LjA2NDAuMA==",
    "nombre": "Agustín Durán Espinosa",
    "archivo": "Agustín Durán Espinosa_NDI3LjA2NDAuMA=="
  },
  //entregacuatro
  {
    "id": "MzNuYW4=",
    "nombre": "ALEXIS URIEL RAMOS CASTILLO",
    "archivo": "ALEXIS URIEL RAMOS CASTILLO_MzNuYW4="
  },
  {
    "id": "MTRuYW4=",
    "nombre": "ANAHI SANDOVAL BASTIDA",
    "archivo": "ANAHI SANDOVAL BASTIDA_MTRuYW4="
  },
  {
    "id": "MjZuYW4=",
    "nombre": "ARMANDO MIRANDA NOLASCO",
    "archivo": "ARMANDO MIRANDA NOLASCO_MjZuYW4="
  },
  {
    "id": "MjRuYW4=",
    "nombre": "DANIELA ELENA RAMOS PONCE",
    "archivo": "DANIELA ELENA RAMOS PONCE_MjRuYW4="
  },
  {
    "id": "MjBuYW4=",
    "nombre": "DIEGO OSBALDO GARCIA CRUZ",
    "archivo": "DIEGO OSBALDO GARCIA CRUZ_MjBuYW4="
  },
  {
    "id": "MTluYW4=",
    "nombre": "HECTOR ADAIR ALVARADO SALAS",
    "archivo": "HECTOR ADAIR ALVARADO SALAS_MTluYW4="
  },
  {
    "id": "MjFuYW4=",
    "nombre": "JANCEL EMANUEL PEREZ VALADEZ",
    "archivo": "JANCEL EMANUEL PEREZ VALADEZ_MjFuYW4="
  },
  {
    "id": "MTVuYW4=",
    "nombre": "JOSE ANGEL AVILES PEREDA",
    "archivo": "JOSE ANGEL AVILES PEREDA_MTVuYW4="
  },
  {
    "id": "MzJuYW4=",
    "nombre": "JOVANI REYES CORTES",
    "archivo": "JOVANI REYES CORTES_MzJuYW4="
  },
  {
    "id": "MTZuYW4=",
    "nombre": "KAREN ZULEIMA LOPEZ SANCHEZ",
    "archivo": "KAREN ZULEIMA LOPEZ SANCHEZ_MTZuYW4="
  },
  {
    "id": "MTduYW4=",
    "nombre": "KARLA HORTENSIA RUIZ CORTES",
    "archivo": "KARLA HORTENSIA RUIZ CORTES_MTduYW4="
  },
  {
    "id": "MjJuYW4=",
    "nombre": "LESLIE GUTIERREZ RAYA",
    "archivo": "LESLIE GUTIERREZ RAYA_MjJuYW4="
  },
  {
    "id": "MjcyN25hbg==",
    "nombre": "LESLY YAMILE MARTINEZ HERNANDEZ",
    "archivo": "LESLY YAMILE MARTINEZ HERNANDEZ_MjcyN25hbg=="
  },
  {
    "id": "MjVuYW4=",
    "nombre": "MA. BELEN LOPEZ CRUZ",
    "archivo": "MA. BELEN LOPEZ CRUZ_MjVuYW4="
  },
  {
    "id": "MjgyOG5hbg==",
    "nombre": "MA. DEL ROSARIO ZUÑIGA TELLO",
    "archivo": "MA. DEL ROSARIO ZUÑIGA TELLO_MjgyOG5hbg=="
  },
  {
    "id": "MzBuYW4=",
    "nombre": "RAFAELA GOMEZ DE LEON",
    "archivo": "RAFAELA GOMEZ DE LEON_MzBuYW4="
  },
  {
    "id": "MThuYW4=",
    "nombre": "RENEE MALENY VIGIL RUIZ",
    "archivo": "RENEE MALENY VIGIL RUIZ_MThuYW4="
  },
  {
    "id": "MTBuYW4=",
    "nombre": "RODRIGO JESUS CORTES QUINTERO",
    "archivo": "RODRIGO JESUS CORTES QUINTERO_MTBuYW4="
  },
  {
    "id": "MjNuYW4=",
    "nombre": "SAMUEL DAVID MARIN SANCHEZ",
    "archivo": "SAMUEL DAVID MARIN SANCHEZ_MjNuYW4="
  },
  {
    "id": "MzVuYW4=",
    "nombre": "VICTOR ANDRADE LEON",
    "archivo": "VICTOR ANDRADE LEON_MzVuYW4="
  },
  {
    "id": "MTJuYW4=",
    "nombre": "WENDY MICHELLE BETANCOURT ZAMARRON",
    "archivo": "WENDY MICHELLE BETANCOURT ZAMARRON_MTJuYW4="
  },
  {
    "id": "MTFuYW4=",
    "nombre": "WENDY PAMELA GUTIERREZ PIÑA",
    "archivo": "WENDY PAMELA GUTIERREZ PIÑA_MTFuYW4="
  },
  {
    "id": "MzduYW4=",
    "nombre": "AMANDA RODRIGUEZ HERNANDEZ",
    "archivo": "AMANDA RODRIGUEZ HERNANDEZ_MzduYW4="
  },
  {
    "id": "NzBuYW4=",
    "nombre": "ANABEL MAGALLANES OROSCO",
    "archivo": "ANABEL MAGALLANES OROSCO_NzBuYW4="
  },
  {
    "id": "NjJuYW4=",
    "nombre": "ANGEL EDUARDO FABELA CELAYA",
    "archivo": "ANGEL EDUARDO FABELA CELAYA_NjJuYW4="
  },
  {
    "id": "ODFuYW4=",
    "nombre": "ANGELA CONCEPCION UC CAPUL",
    "archivo": "ANGELA CONCEPCION UC CAPUL_ODFuYW4="
  },
  {
    "id": "NjFuYW4=",
    "nombre": "ANGELICA MARIA NEUFELD KNELSEN",
    "archivo": "ANGELICA MARIA NEUFELD KNELSEN_NjFuYW4="
  },
  {
    "id": "NTNuYW4=",
    "nombre": "ARTEMIO BERG ENNS",
    "archivo": "ARTEMIO BERG ENNS_NTNuYW4="
  },
  {
    "id": "NzluYW4=",
    "nombre": "ASHLEY MAURICIO GARCIAGONZALEZ",
    "archivo": "ASHLEY MAURICIO GARCIAGONZALEZ_NzluYW4="
  },
  {
    "id": "NDVuYW4=",
    "nombre": "BRANDON ALEJANDRO LEMUS ESQUIVEL",
    "archivo": "BRANDON ALEJANDRO LEMUS ESQUIVEL_NDVuYW4="
  },
  {
    "id": "NjduYW4=",
    "nombre": "DAVID EMILIANO GALLEGOS TERRAZAS",
    "archivo": "DAVID EMILIANO GALLEGOS TERRAZAS_NjduYW4="
  },
  {
    "id": "NzJuYW4=",
    "nombre": "DAVID PETERS NEUFELD",
    "archivo": "DAVID PETERS NEUFELD_NzJuYW4="
  },
  {
    "id": "NjluYW4=",
    "nombre": "DAVID PETERS NEUFELD",
    "archivo": "DAVID PETERS NEUFELD_NjluYW4="
  },
  {
    "id": "NDluYW4=",
    "nombre": "ELVIA PAMELA MIRANDA GOMEZ",
    "archivo": "ELVIA PAMELA MIRANDA GOMEZ_NDluYW4="
  },
  {
    "id": "NTJuYW4=",
    "nombre": "EMILY WIEBE QUIRING",
    "archivo": "EMILY WIEBE QUIRING_NTJuYW4="
  },
  {
    "id": "NzVuYW4=",
    "nombre": "EMMA ANDREA ORTIZ ALVAREZ",
    "archivo": "EMMA ANDREA ORTIZ ALVAREZ_NzVuYW4="
  },
  {
    "id": "NjZuYW4=",
    "nombre": "ENOS LEVI GARCIA VEGA",
    "archivo": "ENOS LEVI GARCIA VEGA_NjZuYW4="
  },
  {
    "id": "ODBuYW4=",
    "nombre": "ERIC ARIEL HEREDIA ANGULO",
    "archivo": "ERIC ARIEL HEREDIA ANGULO_ODBuYW4="
  },
  {
    "id": "NjNuYW4=",
    "nombre": "EVIGAEL MERINO REY",
    "archivo": "EVIGAEL MERINO REY_NjNuYW4="
  },
  {
    "id": "NDhuYW4=",
    "nombre": "GIOVANNI SANTOS ORTA",
    "archivo": "GIOVANNI SANTOS ORTA_NDhuYW4="
  },
  {
    "id": "NjVuYW4=",
    "nombre": "HAZAEL ARANA GODINEZ",
    "archivo": "HAZAEL ARANA GODINEZ_NjVuYW4="
  },
  {
    "id": "NjBuYW4=",
    "nombre": "IVAN NEUFELD KNELSEN",
    "archivo": "IVAN NEUFELD KNELSEN_NjBuYW4="
  },
  {
    "id": "NDJuYW4=",
    "nombre": "JACOBO ARREOLA LOPEZ",
    "archivo": "JACOBO ARREOLA LOPEZ_NDJuYW4="
  },
  {
    "id": "ODNuYW4=",
    "nombre": "JACQUELINE RODRIGUEZ DIAZ",
    "archivo": "JACQUELINE RODRIGUEZ DIAZ_ODNuYW4="
  },
  {
    "id": "NzZuYW4=",
    "nombre": "JAZMIN ROMERO PIÑUELAS",
    "archivo": "JAZMIN ROMERO PIÑUELAS_NzZuYW4="
  },
  {
    "id": "NjRuYW4=",
    "nombre": "JORGUE ALEJANDRO OLVERA ALONSO",
    "archivo": "JORGUE ALEJANDRO OLVERA ALONSO_NjRuYW4="
  },
  {
    "id": "NzNuYW4=",
    "nombre": "JORGUE EMANUEL HERNANDEZ OROZCO",
    "archivo": "JORGUE EMANUEL HERNANDEZ OROZCO_NzNuYW4="
  },
  {
    "id": "NTBuYW4=",
    "nombre": "JOSE SOLORZANO MEDINA",
    "archivo": "JOSE SOLORZANO MEDINA_NTBuYW4="
  },
  {
    "id": "NThuYW4=",
    "nombre": "JOSHUA RAMSSES RIVERA",
    "archivo": "JOSHUA RAMSSES RIVERA_NThuYW4="
  },
  {
    "id": "NjhuYW4=",
    "nombre": "JOVANNA MARTINEZ MORALES",
    "archivo": "JOVANNA MARTINEZ MORALES_NjhuYW4="
  },
  {
    "id": "MzhuYW4=",
    "nombre": "JUAN MANUEL ORTIZ GUERRERO",
    "archivo": "JUAN MANUEL ORTIZ GUERRERO_MzhuYW4="
  },
  {
    "id": "MzluYW4=",
    "nombre": "LUIS ANGEL GALINDO ABITIA",
    "archivo": "LUIS ANGEL GALINDO ABITIA_MzluYW4="
  },
  {
    "id": "NDRuYW4=",
    "nombre": "JUANA TERESA GARCIA CONTRERAS",
    "archivo": "JUANA TERESA GARCIA CONTRERAS_NDRuYW4="
  },
  {
    "id": "NTduYW4=",
    "nombre": "JULIA BELINDA FRIESSEN",
    "archivo": "JULIA BELINDA FRIESSEN_NTduYW4="
  },
  {
    "id": "NDE0MW5hbg==",
    "nombre": "KEVIN EDUARDO CHAVEZ CRUZ",
    "archivo": "KEVIN EDUARDO CHAVEZ CRUZ_NDE0MW5hbg=="
  },
  {
    "id": "NDZuYW4=",
    "nombre": "KEVIN OSVALDO MARQUEZ RUIZ",
    "archivo": "KEVIN OSVALDO MARQUEZ RUIZ_NDZuYW4="
  },
  {
    "id": "MzFuYW4=",
    "nombre": "KEYLA YAMILET GUZMAN MARTINEZ",
    "archivo": "KEYLA YAMILET GUZMAN MARTINEZ_MzFuYW4="
  },
  {
    "id": "NTVuYW4=",
    "nombre": "LATOYA SAVINA WIEBE KLASSEN",
    "archivo": "LATOYA SAVINA WIEBE KLASSEN_NTVuYW4="
  },
  {
    "id": "NzFuYW4=",
    "nombre": "LEONARDO ACUÑA PALMA",
    "archivo": "LEONARDO ACUÑA PALMA_NzFuYW4="
  },
  {
    "id": "NTFuYW4=",
    "nombre": "LEONEL BARTCH DUECK",
    "archivo": "LEONEL BARTCH DUECK_NTFuYW4="
  },
  {
    "id": "NDNuYW4=",
    "nombre": "LEONIDES PEZA ESCUTIA",
    "archivo": "LEONIDES PEZA ESCUTIA_NDNuYW4="
  },
  {
    "id": "NDduYW4=",
    "nombre": "LIDIA LIZETH CHONG GARCIA",
    "archivo": "LIDIA LIZETH CHONG GARCIA_NDduYW4="
  },
  {
    "id": "NTZuYW4=",
    "nombre": "LUCELIA DIANA BERG FRIESSEN",
    "archivo": "LUCELIA DIANA BERG FRIESSEN_NTZuYW4="
  },
  {
    "id": "MzZuYW4=",
    "nombre": "LUCERO ORTIZ VELAZQUEZ",
    "archivo": "LUCERO ORTIZ VELAZQUEZ_MzZuYW4="
  },
  {
    "id": "ODJuYW4=",
    "nombre": "MARIA TEODOCIA MOO KAUIL",
    "archivo": "MARIA TEODOCIA MOO KAUIL_ODJuYW4="
  },
  {
    "id": "NzRuYW4=",
    "nombre": "OSWALDO MENDOZA GOMEZ",
    "archivo": "OSWALDO MENDOZA GOMEZ_NzRuYW4="
  },
  {
    "id": "NzhuYW4=",
    "nombre": "RICARDO ABRAHAM HERRERA ZENTENO",
    "archivo": "RICARDO ABRAHAM HERRERA ZENTENO_NzhuYW4="
  },
  {
    "id": "NTluYW4=",
    "nombre": "ROBERTO BERGEN WIEBE",
    "archivo": "ROBERTO BERGEN WIEBE_NTluYW4="
  },
  {
    "id": "NzduYW4=",
    "nombre": "YESENIA GUADALUPE OLVEDA CALLES",
    "archivo": "YESENIA GUADALUPE OLVEDA CALLES_NzduYW4="
  },
  {
    "id": "NDBuYW4=",
    "nombre": "YESENIA PAREDES CORONADO",
    "archivo": "YESENIA PAREDES CORONADO_NDBuYW4="
  },
  {
    "id": "MjluYW4=",
    "nombre": "YOHANA RAMOS NOLASCO",
    "archivo": "YOHANA RAMOS NOLASCO_MjluYW4="
  },
  {
    "id": "MTBuYW4=",
    "nombre": "RODRIGO JESUS CORTES QUINTERO",
    "archivo": "RODRIGO JESUS CORTES QUINTERO_MTBuYW4="
  },
  {
    "id": "MzAyMzAybmFu",
    "nombre": "BRENDA MARTINEZ BAÑOS",
    "archivo": "BRENDA MARTINEZ BAÑOS_MzAyMzAybmFu"
  },
  {
    "id": "NDI4NDI4bmFu",
    "nombre": "DANIEL LEONIDES MENDOZA",
    "archivo": "DANIEL LEÓNIDES MENDOZA_NDI4NDI4bmFu"
  },
  {
    "id": "NDI5bmFu",
    "nombre": "JUAN CARLOS PEREZ JIMENEZ",
    "archivo": "JUAN CARLOS PÉREZ JIMÉNEZ_NDI5bmFu"
  },
  {
    "id": "MjAxbmFu",
    "nombre": "CARLOS URIEL HERMENEGILDO ROMERO",
    "archivo": "CARLOS URIEL HERMENEGILDO ROMERO_MjAxbmFu"
  },
  {
    "id": "NDIzbmFu",
    "nombre": "ESTEFANI JIMENA ROSAS NIEVES",
    "archivo": "ESTEFANI JIMENA ROSAS NIEVES_NDIzbmFu"
  },
  {
    "id": "NDI4bmFu",
    "nombre": "LETICIA GOMEZ HERNANDEZ",
    "archivo": "LETICIA GOMEZ HERNANDEZ_NDI4bmFu"
  },
  {
    "id": "MzAybmFu",
    "nombre": "ANDREA ELISA SERVIN ALPIZAR",
    "archivo": "ANDREA ELISA SERVIN ALPIZAR_MzAybmFu"
  },
  {
    "id": "NDA1bmFu",
    "nombre": "DIEGO EMILIANO SOLIS VAZQUEZ",
    "archivo": "DIEGO EMILIANO SOLIS VAZQUEZ_NDA1bmFu"
  },
  {
    "id": "MjhuYW4=",
    "nombre": "JAIME PEDRAZA COTERO",
    "archivo": "JAIME PEDRAZA COTERO_MjhuYW4="
  },
  {
    "id": "MjduYW4=",
    "nombre": "JOSE HUMBERTO AYALA ALFARO",
    "archivo": "JOSE HUMBERTO AYALA ALFARO_MjduYW4="
  },
  {
    "id": "NDI4NDE3NzkxMjguMA==",
    "nombre": "BARBARA PACHECO HERNANDEZ",
    "archivo": "BARBARA PACHECO HERNANDEZ_NDI4NDE3NzkxMjguMA=="
  },
  {
    "id": "NjluYW4=",
    "nombre": "DILAN JOEL DORANTES CARRILLO",
    "archivo": "DILAN JOEL DORANTES CARRILLO_NjluYW4="
  },
  //entragacinco
  {
    "id": "MTA1MQ==",
    "nombre": "ANGEL URIEL HERNANDEZ VAZQUEZ",
    "archivo": "ANGEL URIEL HERNANDEZ VAZQUEZ_MTA1MQ=="
  },
  {
    "id": "MTA2Mg==",
    "nombre": "JOSE HUMBERTO AYALA ALFARO",
    "archivo": "JOSE HUMBERTO AYALA ALFARO_MTA2Mg=="
  },
  {
    "id": "MTA3Mw==",
    "nombre": "BRENDA BERENICE HERNANDEZ MONDRAGON",
    "archivo": "BRENDA BERENICE HERNANDEZ MONDRAGON_MTA3Mw=="
  },
  {
    "id": "MTA4NA==",
    "nombre": "OMAR RIGOBERTO GUERRERO DIMAS",
    "archivo": "OMAR RIGOBERTO GUERRERO DIMAS_MTA4NA=="
  },
  {
    "id": "MTA5NQ==",
    "nombre": "EDWIN CHINGORA HUERTA",
    "archivo": "EDWIN CHINGORA HUERTA_MTA5NQ=="
  },
  {
    "id": "MTEwNg==",
    "nombre": "NATIVIDAD CONTRERAS NAVARRO",
    "archivo": "NATIVIDAD CONTRERAS NAVARRO_MTEwNg=="
  },
  {
    "id": "MTExNw==",
    "nombre": "JAIME PEDRAZA COTERO",
    "archivo": "JAIME PEDRAZA COTERO_MTExNw=="
  },
  {
    "id": "MTEyOA==",
    "nombre": "INGRID CAMACHO ZARAGOZA",
    "archivo": "INGRID CAMACHO ZARAGOZA_MTEyOA=="
  },
  {
    "id": "MTEzOQ==",
    "nombre": "DIEGO ALBERTO SANDOVAL VAZQUEZ",
    "archivo": "DIEGO ALBERTO SANDOVAL VAZQUEZ_MTEzOQ=="
  },
  {
    "id": "MTE0MTA=",
    "nombre": "EDUARDO AGUILAR CEDILLO",
    "archivo": "EDUARDO AGUILAR CEDILLO_MTE0MTA="
  },
  {
    "id": "MTYxMQ==",
    "nombre": "DIANA PAOLA ORTEGA ISLAS",
    "archivo": "DIANA PAOLA ORTEGA ISLAS_MTYxMQ=="
  },
  {
    "id": "MTE2MTI=",
    "nombre": "DIANA VALERIA REYES XILO",
    "archivo": "DIANA VALERIA REYES XILO_MTE2MTI="
  },
  {
    "id": "MTE3MTM=",
    "nombre": "ANGEL ELIEZER GARCES GARCIA",
    "archivo": "ANGEL ELIEZER GARCES GARCIA_MTE3MTM="
  },
  {
    "id": "MTE4MTQ=",
    "nombre": "MILDRED RAMOS BANDA",
    "archivo": "MILDRED RAMOS BANDA_MTE4MTQ="
  },
  {
    "id": "MTE5MTU=",
    "nombre": "EMMANUEL MOCTEZUMA ROSALES",
    "archivo": "EMMANUEL MOCTEZUMA ROSALES_MTE5MTU="
  },
  {
    "id": "MTIxMTY=",
    "nombre": "MARCOS ALBERTO AVILES JIMENEZ",
    "archivo": "MARCOS ALBERTO AVILES JIMENEZ_MTIxMTY="
  },
  {
    "id": "MTIyMTc=",
    "nombre": "ADRIAN BECERRIL ARIAS",
    "archivo": "ADRIAN BECERRIL ARIAS_MTIyMTc="
  },
  {
    "id": "MTIzMTg=",
    "nombre": "GUILLERMINA VAZQUEZ VARGAS",
    "archivo": "GUILLERMINA VAZQUEZ VARGAS_MTIzMTg="
  },
  {
    "id": "MTI0MTk=",
    "nombre": "MIRIAM MARTINEZ MENDOZA",
    "archivo": "MIRIAM MARTINEZ MENDOZA_MTI0MTk="
  },
  {
    "id": "MTI1MjA=",
    "nombre": "ALEXANDER MARTINEZ ZEPEDA",
    "archivo": "ALEXANDER MARTINEZ ZEPEDA_MTI1MjA="
  },
  {
    "id": "MTI3MjE=",
    "nombre": "DORIAN OCTAVIO TOVAR ARCOS",
    "archivo": "DORIAN OCTAVIO TOVAR ARCOS_MTI3MjE="
  },
  {
    "id": "MzAyMg==",
    "nombre": "RAFAELA GOMEZ DE LEON",
    "archivo": "RAFAELA GOMEZ DE LEON_MzAyMg=="
  },
  {
    "id": "MTI4MjM=",
    "nombre": "BERTHA YESENIA URBANO HERNANDEZ",
    "archivo": "BERTHA YESENIA URBANO HERNANDEZ_MTI4MjM="
  },
  {
    "id": "MTI5MjQ=",
    "nombre": "DANELIA ROMERO VAZQUEZ",
    "archivo": "DANELIA ROMERO VAZQUEZ_MTI5MjQ="
  },
  {
    "id": "MTIwMjU=",
    "nombre": "JOSE LUIS DOMINGUEZ JUAREZ",
    "archivo": "JOSE LUIS DOMINGUEZ JUAREZ_MTIwMjU="
  },
  {
    "id": "MTMwMjY=",
    "nombre": "GERARDO PUSIAN CISNEROS",
    "archivo": "GERARDO PUSIAN CISNEROS_MTMwMjY="
  },
  {
    "id": "MTMxMjc=",
    "nombre": "ALEXANDRA DE ROA SANTOS",
    "archivo": "ALEXANDRA DE ROA SANTOS_MTMxMjc="
  },
  {
    "id": "MTMyMjg=",
    "nombre": "KIMBERLY SAMANTHA DE ROA SANTOS",
    "archivo": "KIMBERLY SAMANTHA DE ROA SANTOS_MTMyMjg="
  },
  {
    "id": "MTMzMjk=",
    "nombre": "GUILLERMO ARTURO NAJERA ARELLANO",
    "archivo": "GUILLERMO ARTURO NAJERA ARELLANO_MTMzMjk="
  },
  {
    "id": "MTM0MzA=",
    "nombre": "BLANCA ISABEL SOTO LOERA",
    "archivo": "BLANCA ISABEL SOTO LOERA_MTM0MzA="
  },
  {
    "id": "MTM1MzE=",
    "nombre": "LUCIO ANGEL RIOS FLORES",
    "archivo": "LUCIO ANGEL RIOS FLORES_MTM1MzE="
  },
  {
    "id": "MTM2MzI=",
    "nombre": "JORGE ALBERTO GARCIA TORRES",
    "archivo": "JORGE ALBERTO GARCIA TORRES_MTM2MzI="
  },
  {
    "id": "MTM3MzM=",
    "nombre": "ERIKA TREJO HERNANDEZ",
    "archivo": "ERIKA TREJO HERNANDEZ_MTM3MzM="
  },
  {
    "id": "MTM4MzQ=",
    "nombre": "JANETH JARAMILLO BUENDIA",
    "archivo": "JANETH JARAMILLO BUENDIA_MTM4MzQ="
  },
  {
    "id": "MTM5MzU=",
    "nombre": "ANGELA CONCEPCION UC CUPUL",
    "archivo": "ANGELA CONCEPCION UC CUPUL_MTM5MzU="
  },
  {
    "id": "MTQwMzY=",
    "nombre": "GABRIELA BARBOZA REYES",
    "archivo": "GABRIELA BARBOZA REYES_MTQwMzY="
  },
  {
    "id": "MzQzNw==",
    "nombre": "LAURA ELENA ALVAREZ GUTIERREZ",
    "archivo": "LAURA ELENA ALVAREZ GUTIERREZ_MzQzNw=="
  },
  {
    "id": "MTQyMzg=",
    "nombre": "BARBIE ALEXSANDRA CONTRERAS CRISTOBAL",
    "archivo": "BARBIE ALEXSANDRA CONTRERAS CRISTOBAL_MTQyMzg="
  },
  {
    "id": "MTQzMzk=",
    "nombre": "REFUGIO SOLORIO BENITEZ",
    "archivo": "REFUGIO SOLORIO BENITEZ_MTQzMzk="
  },
  {
    "id": "MTQ0NDA=",
    "nombre": "DANEY CISNEROS HERNANDEZ",
    "archivo": "DANEY CISNEROS HERNANDEZ_MTQ0NDA="
  },
  {
    "id": "MTQ1NDE=",
    "nombre": "JOSE MANUEL ROMERO SALAMANCA",
    "archivo": "JOSE MANUEL ROMERO SALAMANCA_MTQ1NDE="
  },
  {
    "id": "MTQ2NDI=",
    "nombre": "LIBERTAD AMERICA RAMIREZ JIMENEZ",
    "archivo": "LIBERTAD AMERICA RAMIREZ JIMENEZ_MTQ2NDI="
  },
  {
    "id": "MTQ3NDM=",
    "nombre": "LUIS DECO GUZMAN RAMIREZ",
    "archivo": "LUIS DECO GUZMAN RAMIREZ_MTQ3NDM="
  },
  {
    "id": "MTQ4NDQ=",
    "nombre": "JOSE MANUEL NAVARRO FLORES",
    "archivo": "JOSE MANUEL NAVARRO FLORES_MTQ4NDQ="
  },
  {
    "id": "MTQ5NDU=",
    "nombre": "JULIAN UXUE LARA GARCIA",
    "archivo": "JULIAN UXUE LARA GARCIA_MTQ5NDU="
  },
  {
    "id": "MTc0Ng==",
    "nombre": "EMMANUEL MEDINA MORALES",
    "archivo": "EMMANUEL MEDINA MORALES_MTc0Ng=="
  },
  {
    "id": "MTUxNDc=",
    "nombre": "JOSE DANIEL ZARATE NICOLAS",
    "archivo": "JOSE DANIEL ZARATE NICOLAS_MTUxNDc="
  },
  {
    "id": "MTUyNDg=",
    "nombre": "CARLOS ARMANDO GARCIA PUCH",
    "archivo": "CARLOS ARMANDO GARCIA PUCH_MTUyNDg="
  },
  {
    "id": "MTUzNDk=",
    "nombre": "PATRICIA LIZETH RUBIO BARRON",
    "archivo": "PATRICIA LIZETH RUBIO BARRON_MTUzNDk="
  },
  {
    "id": "MTU0NTA=",
    "nombre": "DIEGO ANTONIO BORJAS SANCHEZ",
    "archivo": "DIEGO ANTONIO BORJAS SANCHEZ_MTU0NTA="
  },
  {
    "id": "MTU1NTE=",
    "nombre": "MIGUEL ANGEL LOZANO ZARIÑANA",
    "archivo": "MIGUEL ANGEL LOZANO ZARIÑANA_MTU1NTE="
  },
  {
    "id": "MTU2NTI=",
    "nombre": "JOHN ALEXANDER FLORES GARCIA",
    "archivo": "JOHN ALEXANDER FLORES GARCIA_MTU2NTI="
  },
  {
    "id": "MzU1Mw==",
    "nombre": "JUAN JOSE GONZALEZ VALENCIA",
    "archivo": "JUAN JOSE GONZALEZ VALENCIA_MzU1Mw=="
  },
  {
    "id": "MzYzNTQ=",
    "nombre": "YESENIA GUZMAN NOLASCO",
    "archivo": "YESENIA GUZMAN NOLASCO_MzYzNTQ="
  },
  {
    "id": "MjE1NQ==",
    "nombre": "JANCEL EMANUEL PEREZ VALADEZ",
    "archivo": "JANCEL EMANUEL PEREZ VALADEZ_MjE1NQ=="
  },
  {
    "id": "NzA1Ng==",
    "nombre": "ANABEL MAGALLANES OROZCO",
    "archivo": "ANABEL MAGALLANES OROZCO_NzA1Ng=="
  },
  {
    "id": "MTU3NTc=",
    "nombre": "GRICELDA SANDOVAL SIQUEIROS",
    "archivo": "GRICELDA SANDOVAL SIQUEIROS_MTU3NTc="
  },
  {
    "id": "MTU4NTg=",
    "nombre": "JOSELIN GUADALUPE ZARAGOZA CARRASCO",
    "archivo": "JOSELIN GUADALUPE ZARAGOZA CARRASCO_MTU4NTg="
  },
  {
    "id": "MTU5NTk=",
    "nombre": "MARIANA YAQUELIN LEYVA MORENO",
    "archivo": "MARIANA YAQUELIN LEYVA MORENO_MTU5NTk="
  },
  {
    "id": "MTYwNjA=",
    "nombre": "ROCIO RAMIREZ TORRES",
    "archivo": "ROCIO RAMIREZ TORRES_MTYwNjA="
  },
  {
    "id": "MTYxNjE=",
    "nombre": "SIRIAM SUGEY LEYVA VILLANUEVA",
    "archivo": "SIRIAM SUGEY LEYVA VILLANUEVA_MTYxNjE="
  },
  {
    "id": "MTYyNjI=",
    "nombre": "YEIMIN VALENTINA PEÑA",
    "archivo": "YEIMIN VALENTINA PEÑA_MTYyNjI="
  },
  {
    "id": "MTYzNjM=",
    "nombre": "YURIZBEL JIMENEZ MOLINA",
    "archivo": "YURIZBEL JIMENEZ MOLINA_MTYzNjM="
  },
  {
    "id": "MTY0NjQ=",
    "nombre": "AMILCAR FRANCISCO BERRELLEZ BADILLA",
    "archivo": "AMILCAR FRANCISCO BERRELLEZ BADILLA_MTY0NjQ="
  },
  {
    "id": "MTY1NjU=",
    "nombre": "BLANCA CAMERINA MARTINEZ ANGEL",
    "archivo": "BLANCA CAMERINA MARTINEZ ANGEL_MTY1NjU="
  },
  {
    "id": "MTY2NjY=",
    "nombre": "DIEGO RAMIREZ VILLA",
    "archivo": "DIEGO RAMIREZ VILLA_MTY2NjY="
  },
  {
    "id": "MTY3Njc=",
    "nombre": "IRVING FABIAN VENEGAS LOZANO",
    "archivo": "IRVING FABIAN VENEGAS LOZANO_MTY3Njc="
  },
  {
    "id": "MTY4Njg=",
    "nombre": "MARCO ANTONIO MOSQUEDA COSIO",
    "archivo": "MARCO ANTONIO MOSQUEDA COSIO_MTY4Njg="
  },
  {
    "id": "MTY5Njk=",
    "nombre": "MARTHA ANGELICA ORNELAS MEDINA",
    "archivo": "MARTHA ANGELICA ORNELAS MEDINA_MTY5Njk="
  },
  {
    "id": "MTcwNzA=",
    "nombre": "SANTOS ADRIAN RAMIREZ MORALES",
    "archivo": "SANTOS ADRIAN RAMIREZ MORALES_MTcwNzA="
  },
  {
    "id": "MTcxNzE=",
    "nombre": "ULISES RUIZ DELGADO",
    "archivo": "ULISES RUIZ DELGADO_MTcxNzE="
  },
  {
    "id": "MTcyNzI=",
    "nombre": "VICTOR MANUEL GALICIA ZAMBRANO",
    "archivo": "VICTOR MANUEL GALICIA ZAMBRANO_MTcyNzI="
  },
  {
    "id": "MTczNzM=",
    "nombre": "ALMA OBDULIA GAMEZ GUERRERO",
    "archivo": "ALMA OBDULIA GAMEZ GUERRERO_MTczNzM="
  },
  {
    "id": "MTc0NzQ=",
    "nombre": "JOSE LIZANDRO CANUL DZUL",
    "archivo": "JOSE LIZANDRO CANUL DZUL_MTc0NzQ="
  },
  {
    "id": "MTc1NzU=",
    "nombre": "ENRIQUE AYALA TZUM",
    "archivo": "ENRIQUE AYALA TZUM_MTc1NzU="
  },
  {
    "id": "MTc2NzY=",
    "nombre": "RICARDO CORTEZ CABALLERO",
    "archivo": "RICARDO CORTEZ CABALLERO_MTc2NzY="
  },
  {
    "id": "MTc3Nzc=",
    "nombre": "VICTOR JAHIR MARTINEZ SANCHEZ",
    "archivo": "VICTOR JAHIR MARTINEZ SANCHEZ_MTc3Nzc="
  },
  {
    "id": "MTc4Nzg=",
    "nombre": "ALEXANDER MARTINEZ SANCHEZ",
    "archivo": "ALEXANDER MARTINEZ SANCHEZ_MTc4Nzg="
  },
  {
    "id": "MTc5Nzk=",
    "nombre": "YENIFER GONZALEZ PEREZ",
    "archivo": "YENIFER GONZALEZ PEREZ_MTc5Nzk="
  },
  {
    "id": "MTgwODA=",
    "nombre": "JAHAZIEL ELIEZER MARTINEZ CALDERON",
    "archivo": "JAHAZIEL ELIEZER MARTINEZ CALDERON_MTgwODA="
  },
  {
    "id": "MTgxODE=",
    "nombre": "DANIEL ALEJANDRO REMES ROMO",
    "archivo": "DANIEL ALEJANDRO REMES ROMO_MTgxODE="
  },
  {
    "id": "MTgyODI=",
    "nombre": "JAIRO YAHIR NAVARRETE HERNANDEZ",
    "archivo": "JAIRO YAHIR NAVARRETE HERNANDEZ_MTgyODI="
  },
  {
    "id": "MTgzODM=",
    "nombre": "LUIS FERNANDO RUIZ CAMUÑEZ",
    "archivo": "LUIS FERNANDO RUIZ CAMUÑEZ_MTgzODM="
  },
  {
    "id": "MTg0ODQ=",
    "nombre": "JAZMIN RUBY AVILA MARIN",
    "archivo": "JAZMIN RUBY AVILA MARIN_MTg0ODQ="
  },
  {
    "id": "MTg1ODU=",
    "nombre": "JESUS RAMON RODRIGUEZ DURAN",
    "archivo": "JESUS RAMON RODRIGUEZ DURAN_MTg1ODU="
  },
  {
    "id": "MTg2ODY=",
    "nombre": "JORGE ANTONIO CARBALLO ROCHA",
    "archivo": "JORGE ANTONIO CARBALLO ROCHA_MTg2ODY="
  },
  {
    "id": "MTg3ODc=",
    "nombre": "PAOLA EUNISE ROJO QUIROZ",
    "archivo": "PAOLA EUNISE ROJO QUIROZ_MTg3ODc="
  },
  {
    "id": "MTg4ODg=",
    "nombre": "CELSO ISMAEL SALAS ORTEGA",
    "archivo": "CELSO ISMAEL SALAS ORTEGA_MTg4ODg="
  },
  {
    "id": "MTg5ODk=",
    "nombre": "EDGAR IVAN FLORES QUINTANA",
    "archivo": "EDGAR IVAN FLORES QUINTANA_MTg5ODk="
  },
  {
    "id": "MTkwOTA=",
    "nombre": "GERALDINE JENNIFER JURADO ORTEGA",
    "archivo": "GERALDINE JENNIFER JURADO ORTEGA_MTkwOTA="
  },
  {
    "id": "MTkxOTE=",
    "nombre": "JAZMIN ROMERO PIÑUELAS",
    "archivo": "JAZMIN ROMERO PIÑUELAS_MTkxOTE="
  },
  {
    "id": "MTkyOTI=",
    "nombre": "JOHAN ACOSTA FLORES",
    "archivo": "JOHAN ACOSTA FLORES_MTkyOTI="
  },
  {
    "id": "MTkzOTY=",
    "nombre": "JENNIFER ANDREA VILLA VAZQUEZ",
    "archivo": "JENNIFER ANDREA VILLA VAZQUEZ_MTkzOTY="
  },
  {
    "id": "MTk0OTM=",
    "nombre": "LEONARDO RODRIGUEZ LONGHURST",
    "archivo": "LEONARDO RODRIGUEZ LONGHURST _MTk0OTM="
  },
  {
    "id": "MTk1OTQ=",
    "nombre": "ANA CRISTINA FLORES LOYA",
    "archivo": "ANA CRISTINA FLORES LOYA_MTk1OTQ="
  },
  {
    "id": "MTk2OTU=",
    "nombre": "DIEGO KEVIN FLORES ORDAS",
    "archivo": "DIEGO KEVIN FLORES ORDAS_MTk2OTU="
  },
  {
    "id": "MzY5Nw==",
    "nombre": "JAIME ANTONIO ESMERALDA MARTINEZ",
    "archivo": "JAIME ANTONIO ESMERALDA MARTINEZ_MzY5Nw=="
  },
  {
    "id": "MTk3OTg=",
    "nombre": "OSCAR EMANUEL MORENO CORDOBA",
    "archivo": "OSCAR EMANUEL MORENO CORDOBA_MTk3OTg="
  },
  {
    "id": "MTk4OTk=",
    "nombre": "YESENIA GUADALUPE OLVEDA CALLES",
    "archivo": "YESENIA GUADALUPE OLVEDA CALLES_MTk4OTk="
  },
  {
    "id": "MTk5MTAw",
    "nombre": "CAMILA ARGUILEZ GAMEZ",
    "archivo": "CAMILA ARGUILEZ GAMEZ_MTk5MTAw"
  },
  {
    "id": "MjAwMTAx",
    "nombre": "FLOR ALEXA GARCIA SANCHEZ",
    "archivo": "FLOR ALEXA GARCIA SANCHEZ_MjAwMTAx"
  },
  {
    "id": "MjAxMTAy",
    "nombre": "YOSHELIN ITZEL GARCIA SANCHEZ",
    "archivo": "YOSHELIN ITZEL GARCIA SANCHEZ_MjAxMTAy"
  },
  {
    "id": "MjAyMTAz",
    "nombre": "PEDRO JOSE RAMOS MENDOZA",
    "archivo": "PEDRO JOSE RAMOS MENDOZA_MjAyMTAz"
  },
  {
    "id": "MjAzMTA0",
    "nombre": "CAROLINA JAQUEZ ESPINOZA",
    "archivo": "CAROLINA JAQUEZ ESPINOZA_MjAzMTA0"
  },
  {
    "id": "MjA0MTA1",
    "nombre": "ABRAHAM ANTONIO FLORES FIERRO",
    "archivo": "ABRAHAM ANTONIO FLORES FIERRO_MjA0MTA1"
  },
  {
    "id": "MjA1MTA2",
    "nombre": "ANGEL EDUARDO MEDINILLA DOMINGUEZ",
    "archivo": "ANGEL EDUARDO MEDINILLA DOMINGUEZ_MjA1MTA2"
  },
  {
    "id": "MjA2MTA3",
    "nombre": "ZADQUIEL BERENICE ARTEAGA HARO",
    "archivo": "ZADQUIEL BERENICE ARTEAGA HARO_MjA2MTA3"
  },
  {
    "id": "MjA3MTA4",
    "nombre": "MARIANA SERRANO CASTILLO",
    "archivo": "MARIANA SERRANO CASTILLO_MjA3MTA4"
  },
  {
    "id": "MjA4MTA5",
    "nombre": "SORAYA VANESSA HUESCA TORRES",
    "archivo": "SORAYA VANESSA HUESCA TORRES_MjA4MTA5"
  },
  {
    "id": "MjA5MTEw",
    "nombre": "DANIEL RIVERA FUENTES",
    "archivo": "DANIEL RIVERA FUENTES_MjA5MTEw"
  },
  {
    "id": "MjEwMTEx",
    "nombre": "LORENZO ANTONIO ARRAS TAPIA",
    "archivo": "LORENZO ANTONIO ARRAS TAPIA_MjEwMTEx"
  },
  {
    "id": "MjExMTEy",
    "nombre": "DENISSE GUADALUPE ACOSTA ACUÑA",
    "archivo": "DENISSE GUADALUPE ACOSTA ACUÑA_MjExMTEy"
  },
  {
    "id": "MjEyMTEz",
    "nombre": "SAMUEL MENDOZA MENDOZA",
    "archivo": "SAMUEL MENDOZA MENDOZA_MjEyMTEz"
  },
  {
    "id": "MjEzMTE0",
    "nombre": "JOSE EDUARDO VEGA HERNANDEZ",
    "archivo": "JOSE EDUARDO VEGA HERNANDEZ_MjEzMTE0"
  },
  {
    "id": "MjE0MTE1",
    "nombre": "EDWIN ARMANDO JACOBO VAZQUEZ",
    "archivo": "EDWIN ARMANDO JACOBO VAZQUEZ_MjE0MTE1"
  },
  {
    "id": "MjE1MTE2",
    "nombre": "JESUS ALEJANDRO GONZALEZ GONZALEZ",
    "archivo": "JESUS ALEJANDRO GONZALEZ GONZALEZ_MjE1MTE2"
  },
  {
    "id": "MzUzMTE3",
    "nombre": "JUAN ALBERTO MONGE SALAZAR",
    "archivo": "JUAN ALBERTO MONGE SALAZAR_MzUzMTE3"
  },
  {
    "id": "MjQxMTg=",
    "nombre": "DANIELA ELENA RAMOS PONCE",
    "archivo": "DANIELA ELENA RAMOS PONCE_MjQxMTg="
  },
  {
    "id": "NjQxMTk=",
    "nombre": "VICTOR OZIEL MARTINEZ BARUCH",
    "archivo": "VICTOR OZIEL MARTINEZ BARUCH_NjQxMTk="
  },
  // Lote 6
  {
    "id": "MTI2NzgxMTEw",
    "nombre": "Abigail Andrea Verde Calderón",
    "archivo": "Abigail Andrea Verde Calderón_MTI2NzgxMTEw"
  },
  {
    "id": "MTI2NzgyMTEy",
    "nombre": "Adriana Hernández Ortiz",
    "archivo": "Adriana Hernández Ortiz_MTI2NzgyMTEy"
  },
  {
    "id": "MTI2NzgzMTEz",
    "nombre": "Alejandro Fermín Montiel Fuentes",
    "archivo": "Alejandro Fermín Montiel Fuentes_MTI2NzgzMTEz"
  },
  {
    "id": "MTIwNTY0NTc=",
    "nombre": "Aldo Jhovanni Silva López",
    "archivo": "Aldo Jhovanni Silva López _MTIwNTY0NTc="
  },
  {
    "id": "MTI2Nzg1NTc=",
    "nombre": "Alan Asael Martínez González",
    "archivo": "Alan Asael Martínez González_MTI2Nzg1NTc="
  },
  {
    "id": "MTI2Nzg2MTE0",
    "nombre": "Angelica Maelhy Leija Reyes",
    "archivo": "Angelica Maelhy Leija Reyes _MTI2Nzg2MTE0"
  },
  {
    "id": "MTI2Nzg3MTE0",
    "nombre": "Angelica Monserrat Tello Muñoz",
    "archivo": "Angelica Monserrat Tello Muñoz_MTI2Nzg3MTE0"
  },
  {
    "id": "MTI2Nzg4MTE1",
    "nombre": "Anel Soledad Vázquez Nuñez",
    "archivo": "Anel Soledad Vázquez Nuñez_MTI2Nzg4MTE1"
  },
  {
    "id": "MTIwNTY5MTg=",
    "nombre": "Becky Alejandra Calderon Rosado",
    "archivo": "Becky Alejandra Calderon Rosado_MTIwNTY5MTg="
  },
  {
    "id": "MTI2NzgxMDExNg==",
    "nombre": "Brandon Jesús Macedo Tovar",
    "archivo": "Brandon Jesús Macedo Tovar_MTI2NzgxMDExNg=="
  },
  {
    "id": "MTI2NzgxMTExNw==",
    "nombre": "Celina Martinez Mancilla",
    "archivo": "Celina Martinez Mancilla_MTI2NzgxMTExNw=="
  },
  {
    "id": "MTI2NzgxMjExOA==",
    "nombre": "César Anthony Chacón Lara",
    "archivo": "César Anthony Chacón Lara_MTI2NzgxMjExOA=="
  },
  {
    "id": "MTI2NzgxMzExOQ==",
    "nombre": "Cesia Jerusa Márquez Reyna",
    "archivo": "Cesia Jerusa Márquez Reyna_MTI2NzgxMzExOQ=="
  },
  {
    "id": "MTI2NzgxNDEyMA==",
    "nombre": "Ciro Gómez Izquierdo",
    "archivo": "Ciro Gómez Izquierdo_MTI2NzgxNDEyMA=="
  },
  {
    "id": "MTI2NzgxNTEyMQ==",
    "nombre": "Diana Noemí Cen Jiménez",
    "archivo": "Diana Noemí Cen Jiménez_MTI2NzgxNTEyMQ=="
  },
  {
    "id": "MTI2NzgxNjEyMg==",
    "nombre": "Edmundo Yampool Solorzano Hernández",
    "archivo": "Edmundo Yampool Solorzano Hernández_MTI2NzgxNjEyMg=="
  },
  {
    "id": "MTI2NzgxNzEyMw==",
    "nombre": "Eduardo Benjamín Hernández Navarro",
    "archivo": "Eduardo Benjamín Hernández Navarro_MTI2NzgxNzEyMw=="
  },
  {
    "id": "MTI2NzgxODEyNA==",
    "nombre": "Elda Morelos de los Reyes",
    "archivo": "Elda Morelos de los Reyes_MTI2NzgxODEyNA=="
  },
  {
    "id": "MTI2NzgxOTEyNQ==",
    "nombre": "Elisa Mateos Díaz",
    "archivo": "Elisa Mateos Díaz_MTI2NzgxOTEyNQ=="
  },
  {
    "id": "MTI2NzgyMDEyNg==",
    "nombre": "Emiliano Ávalos Aguirre",
    "archivo": "Emiliano Ávalos Aguirre_MTI2NzgyMDEyNg=="
  },
  {
    "id": "MTI2NzgyMTEyNw==",
    "nombre": "Emmanuel Almaraz Loera",
    "archivo": "Emmanuel Almaraz Loera_MTI2NzgyMTEyNw=="
  },
  {
    "id": "MTI2NzgyMjEyOA==",
    "nombre": "Erick Michel Covarrubias Ramírez",
    "archivo": "Erick Michel Covarrubias Ramírez_MTI2NzgyMjEyOA=="
  },
  {
    "id": "MTI2NzgyMzEyOQ==",
    "nombre": "Eveyda Díaz Torruco",
    "archivo": "Eveyda Díaz Torruco_MTI2NzgyMzEyOQ=="
  },
  {
    "id": "MTI2NzgyNDEzMA==",
    "nombre": "Fernando Colin Alvarez",
    "archivo": "Fernando Colin Alvarez_MTI2NzgyNDEzMA=="
  },
  {
    "id": "MTI2NzgyNTEzMQ==",
    "nombre": "Filiberto Martinez Martinez",
    "archivo": "Filiberto Martinez Martinez_MTI2NzgyNTEzMQ=="
  },
  {
    "id": "MTI2NzgyNjEzMg==",
    "nombre": "Francisco Sánchez Ariza",
    "archivo": "Francisco Sánchez Ariza_MTI2NzgyNjEzMg=="
  },
  {
    "id": "MTI2NzgyNzEzMw==",
    "nombre": "Gregorio Torres Rodríguez",
    "archivo": "Gregorio Torres Rodríguez_MTI2NzgyNzEzMw=="
  },
  {
    "id": "MTI2NzgyODEzNA==",
    "nombre": "Hugo Melchor Muñoz",
    "archivo": "Hugo Melchor Muñoz_MTI2NzgyODEzNA=="
  },
  {
    "id": "MTI2NzgyOTEzNQ==",
    "nombre": "Jarlasar Neftalí Ramírez Verino",
    "archivo": "Jarlasar Neftalí Ramírez Verino_MTI2NzgyOTEzNQ=="
  },
  {
    "id": "MTI2NzgzMDEzNg==",
    "nombre": "Jomahira Alvarado Cordova",
    "archivo": "Jomahira Alvarado Cordova_MTI2NzgzMDEzNg=="
  },
  {
    "id": "MTI2NzgzMTEzNw==",
    "nombre": "Jonatan García Palomo",
    "archivo": "Jonatan García Palomo_MTI2NzgzMTEzNw=="
  },
  {
    "id": "MTIwNzgzMjEzOA==",
    "nombre": "José Antonio Cruz Íñiguez",
    "archivo": "José Antonio Cruz Íñiguez_MTIwNzgzMjEzOA=="
  },
  {
    "id": "MTI2NzgzMzEzOQ==",
    "nombre": "José Emiliano Cervantes Valdez",
    "archivo": "José Emiliano Cervantes Valdez_MTI2NzgzMzEzOQ=="
  },
  {
    "id": "MTI2NzgzNDE0Mw==",
    "nombre": "José Eulalio Hernández Cabrera",
    "archivo": "José Eulalio Hernández Cabrera_MTI2NzgzNDE0Mw=="
  },
  {
    "id": "MTI2NzgzNTE0MA==",
    "nombre": "José Rogelio May Cante",
    "archivo": "José Rogelio May Cante_MTI2NzgzNTE0MA=="
  },
  {
    "id": "MTI2NzgzNjE0MQ==",
    "nombre": "Juan Pablo Leyva Alcúdia",
    "archivo": "Juan Pablo Leyva Alcúdia_MTI2NzgzNjE0MQ=="
  },
  {
    "id": "MTI2NzgzNzE0Mg==",
    "nombre": "Joshiel Arzate Soria",
    "archivo": "Joshiel Arzate Soria_MTI2NzgzNzE0Mg=="
  },
  {
    "id": "MTI2NzgzODE0NA==",
    "nombre": "Judith Elena Sandoval Zurita",
    "archivo": "Judith Elena Sandoval Zurita_MTI2NzgzODE0NA=="
  },
  {
    "id": "MTI2NzgzOTE0NQ==",
    "nombre": "Laura Perez Hernández",
    "archivo": "Laura Perez Hernández _MTI2NzgzOTE0NQ=="
  },
  {
    "id": "MTI2Nzg0MDE0Ng==",
    "nombre": "Lestat Alexander Trejo Ventura",
    "archivo": "Lestat Alexander Trejo Ventura_MTI2Nzg0MDE0Ng=="
  },
  {
    "id": "MTI2Nzg0MTE0Nw==",
    "nombre": "Lizbeidy Carolina Ramirez Cruz",
    "archivo": "Lizbeidy Carolina Ramirez Cruz_MTI2Nzg0MTE0Nw=="
  },
  {
    "id": "MTI2Nzg0MjE0OA==",
    "nombre": "Lizeth Alejandra González Rodríguez",
    "archivo": "Lizeth Alejandra González Rodríguez_MTI2Nzg0MjE0OA=="
  },
  {
    "id": "MTI2Nzg0MzE0OQ==",
    "nombre": "Luis Martinez Montes de Oca",
    "archivo": "Luis Martinez Montes de Oca_MTI2Nzg0MzE0OQ=="
  },
  {
    "id": "MTI2Nzg0NDE1MA==",
    "nombre": "Marcos Josafat Rivera González",
    "archivo": "Marcos Josafat Rivera González_MTI2Nzg0NDE1MA=="
  },
  {
    "id": "MTI2Nzg0NTE1MQ==",
    "nombre": "Mario Gael Morales Mundo",
    "archivo": "Mario Gael Morales Mundo_MTI2Nzg0NTE1MQ=="
  },
  {
    "id": "MTI2Nzg0NjE1Mg==",
    "nombre": "María de Lourdes bernal Peñaloza",
    "archivo": "María de Lourdes bernal Peñaloza_MTI2Nzg0NjE1Mg=="
  },
  {
    "id": "MTI2Nzg0NzE1Mw==",
    "nombre": "María del Pilar Arias Alemán",
    "archivo": "María del Pilar Arias Alemán_MTI2Nzg0NzE1Mw=="
  },
  {
    "id": "MTI2Nzg0ODE1NQ==",
    "nombre": "Mauricio Hernández García",
    "archivo": "Mauricio Hernández García_MTI2Nzg0ODE1NQ=="
  },
  {
    "id": "MTI2Nzg0OTE1NA==",
    "nombre": "Mayte Bibiana Sandez García",
    "archivo": "Mayte Bibiana Sandez García_MTI2Nzg0OTE1NA=="
  },
  {
    "id": "MTI2Nzg1MDE1Ng==",
    "nombre": "Miguel Angel Gamas Montalvo",
    "archivo": "Miguel Angel Gamas Montalvo_MTI2Nzg1MDE1Ng=="
  },
  {
    "id": "MTI2Nzg1MTE1Nw==",
    "nombre": "Osmar Roberto Tenorio Torres",
    "archivo": "Osmar Roberto Tenorio Torres_MTI2Nzg1MTE1Nw=="
  },
  {
    "id": "MTI2Nzg1MjE1OA==",
    "nombre": "Regina Saldaña Suaste",
    "archivo": "Regina Saldaña Suaste_MTI2Nzg1MjE1OA=="
  },
  {
    "id": "MTI2Nzg1MzE1OQ==",
    "nombre": "Reina Nova Salinas",
    "archivo": "Reina Nova Salinas_MTI2Nzg1MzE1OQ=="
  },
  {
    "id": "MTI2Nzg1NDE1OQ==",
    "nombre": "Ricardo Hernández",
    "archivo": "Ricardo Hernández_MTI2Nzg1NDE1OQ=="
  },
  {
    "id": "MTI2Nzg1NTE2MA==",
    "nombre": "Ricardo Rodríguez Corona",
    "archivo": "Ricardo Rodríguez Corona_MTI2Nzg1NTE2MA=="
  },
  {
    "id": "MTI2Nzg1NjE2MQ==",
    "nombre": "Rosa Nelly Ortiz González",
    "archivo": "Rosa Nelly Ortiz González_MTI2Nzg1NjE2MQ=="
  },
  {
    "id": "MTI2Nzg1NzE2Mg==",
    "nombre": "Silvia Olivia Rangel Vidales",
    "archivo": "Silvia Olivia Rangel Vidales_MTI2Nzg1NzE2Mg=="
  },
  {
    "id": "MTI2Nzg1ODE2NA==",
    "nombre": "Sofia Jhosseline González Monreal",
    "archivo": "Sofia Jhosseline González Monreal_MTI2Nzg1ODE2NA=="
  },
  {
    "id": "MTI2Nzg1OTE2NQ==",
    "nombre": "Sonia Hernández Cortez",
    "archivo": "Sonia Hernández Cortez_MTI2Nzg1OTE2NQ=="
  },
  {
    "id": "MTI2Nzg2MDE2Ng==",
    "nombre": "Uriel García Lozoya",
    "archivo": "Uriel García Lozoya_MTI2Nzg2MDE2Ng=="
  },
  {
    "id": "MTI2Nzg2MTE2Nw==",
    "nombre": "Victor Alfonso Vega García",
    "archivo": "Victor Alfonso Vega García_MTI2Nzg2MTE2Nw=="
  },
  {
    "id": "MTI2Nzg2MjE2Ng==",
    "nombre": "Victor Hugo Jiménez Miranda",
    "archivo": "Victor Hugo Jiménez Miranda_MTI2Nzg2MjE2Ng=="
  },
  {
    "id": "MTI2Nzg2MzE2Nw==",
    "nombre": "Yerexel Gilberto García Monzón",
    "archivo": "Yerexel Gilberto García Monzón_MTI2Nzg2MzE2Nw=="
  },
  {
    "id": "MTI2Nzg2NDE2OA==",
    "nombre": "Raul Morales Romero",
    "archivo": "Raul Morales Romero_MTI2Nzg2NDE2OA=="
  },
  {
    "id": "MTI2Nzg2NTE2OQ==",
    "nombre": "Oscar Alejandro Peralta Buendia",
    "archivo": "Oscar Alejandro Peralta Buendia _MTI2Nzg2NTE2OQ=="
  },
  {
    "id": "MTI2Nzg2NjE3MA==",
    "nombre": "Fabricio Navarrete Vazquez",
    "archivo": "Fabricio Navarrete Vazquez _MTI2Nzg2NjE3MA=="
  },
  {
    "id": "MTIwNTY2NzEy",
    "nombre": "Jonathan Michelle Santos Ortiz",
    "archivo": "Jonathan Michelle Santos Ortiz_MTIwNTY2NzEy"
  }

];

export const personasMap: Map<string, Alumnos> = new Map(
  personas.map(p => [p.id, p])
);
